const i18n = {
    Languages: {  
        //BCP 47 codes in comments
        'en':'English', //'en-US'
        'fr':'French', //'fr-FR'
        'sp':'Spanish', //'es-ES'
        'gr':'German', //'de-DE'
        'por':'Portuguese (BR)', //'pt-BR'
        'pteu': 'Portuguese (EU)', //'pt-PT'
        'tur': 'Turkish', //'tr-TR'
        'th':'Thai', //'th-TH'
        'vi':'Vietnamese', //'vi'
        'ko':'Korean', //'ko-KR'
        'zh':'Chinese Simplified', //'zh'
        'ru':'Russian', //'ru-RU'
        'it':'Italian', //'it-IT'
        'hu':'Hungarian', //'hu-HU'
        'pl':'Polish' //'pl-PL'
    },
    ConvertedLanguages: {  
        //BCP 47 codes from our custom code
        'en': 'en-US',
        'fr': 'fr-FR',
        'sp': 'es-ES',
        'gr': 'de-DE',
        'por': 'pt-BR',
        'pteu': 'pt-PT',
        'tur': 'tr-TR',
        'th': 'th-TH',
        'vi': 'vi',
        'ko': 'ko-KR',
        'zh': 'zh',
        'ru': 'ru-RU',
        'it': 'it-IT',
        'hu': 'hu-HU',
        'pl': 'pl-PL',
    },
    BannerImportantMessageTitle: {
        'en':'Important Message',
        'fr':'Message Important',
        'sp':'Mensaje Importante',
        'gr':'Wichtige Nachricht',
        'por':'Mensagem Importante',
		'pteu':"Mensagem Importante",
        'tur':'Önemli mesaj',
        'th':'ข้อความสำคัญ',
        'vi':'Thông báo quan trọng',
        'ko':'중요 메시지',
        'zh':'重要信息',
        'it':'Messaggio Importante',
        'hu':'Fontos üzenet',
        'pl':'Ważna Wiadomość'
    },
    PlannedOutageBannerMessage: {
        'en':'The E-Commerce Portal is currently down for planned maintenance from approximately ||@startdate to @enddate. Please try back later.',
        'fr':'Le portail d’e-commerce sera indisponible pour une maintenance planifiée du ||@startdate au @enddate. Veuillez réessayer plus tard.',
        'sp':'El portal de comercio electrónico estará fuera de servicio por mantenimiento planificado desde el ||@startdate hasta el @enddate. Inténtelo de nuevo más tarde.',
        'gr':'Das E-Commerce-Portal ist wegen geplanter Wartungsarbeiten von ||@startdate bis @enddate nicht erreichbar. Bitte versuchen Sie es später noch einmal.',
        'por':'O Portal de comércio eletrônico permanecerá fora do ar para manutenção planejada de ||@startdate a @enddate. Tente novamente mais tarde',
		'pteu':"O Portal de comércio eletrónico ficará inativo para manutenção planeada de ||@startdate a @enddate. Tente novamente mais tarde.",
        'tur':'E-Ticaret Portalı, planlı bakım için ||@startdate ila @enddate arasında servis dışı olacaktır. Lütfen daha sonra tekrar deneyin.',
        'th':'พอร์ทัลอีคอมเมิร์ซจะหยุดให้บริการเพื่อรับการบำรุงรักษาตามแผนตั้งแต่ ||@startdate ถึง @enddate. โปรดลองอีกครั้งในภายหลัง',
        'vi':'Cổng thương mại sẽ tạm dừng hoạt động để bảo trì theo kế hoạch từ ||@startdate đến @enddate. Vui lòng thử lại sau.',
        'ko':'전자상거래 포털은 유지보수를 위해 ||@startdate ~ @enddate 기간 동안 중단됩니다. 나중에 다시 시도하십시오.',
        'zh':'电子商务门户将从 ||@startdate 至 @enddate 关闭以进行计划内维护. 请稍后再试.',
        'it':'Il portale di e-commerce non sarà disponibile a causa di una manutenzione pianificata dal giorno ||@startdate al giorno @enddate. Riprova più tardi.',
        'hu':'Az e-kereskedelmi portál a tervezett karbantartások miatt nem lesz elérhető ||@startdate tól @enddate ig. Kérjük, próbálja meg később.',
        'pl':'Portal E-Commerce będzie nieaktywny z powodu konserwacji planowanej od ||@startdate do @enddate. Spróbuj ponownie później'
    },
    // RegionalPlannedOutageBannerMessage: {
    //     'en':'The E-Commerce Portal is currently down for a planned upgrade thru June 22nd. Please contact <email>support.usca@guardian.com</email> for orders and <email>claims.usca@guardian.com</email> for claims during this time or please contact your Sales Representative.',
    //     'fr':'Le portail E-commerce est actuellement indisponible pour une mise à jour jusqu’au 22 juin. Veuillez contacter <email>support.usca@guardian.com</email> pour les commandes et <email>claims.usca@guardian.com</email> pour les réclamations pendant cette période ou contactez votre représentant commercial.',
    
    RegionalPlannedOutageBannerMessage: {
        'en':'The E-Commerce Portal is currently down for planned maintenance from approximately ||@startdate to @enddate. Please try back later.',
        'fr':'Le portail d’e-commerce sera indisponible pour une maintenance planifiée du ||@startdate au @enddate. Veuillez réessayer plus tard.',
        'sp':'El portal de comercio electrónico estará fuera de servicio por mantenimiento planificado desde el ||@startdate hasta el @enddate. Inténtelo de nuevo más tarde.',
        'gr':'Das E-Commerce-Portal ist wegen geplanter Wartungsarbeiten von ||@startdate bis @enddate nicht erreichbar. Bitte versuchen Sie es später noch einmal.',
        'por':'O Portal de comércio eletrônico permanecerá fora do ar para manutenção planejada de ||@startdate a @enddate. Tente novamente mais tarde',
		'pteu':"O Portal de comércio eletrónico ficará inativo para manutenção planeada de ||@startdate a @enddate. Tente novamente mais tarde.",
        'tur':'E-Ticaret Portalı, planlı bakım için ||@startdate ila @enddate arasında servis dışı olacaktır. Lütfen daha sonra tekrar deneyin.',
        'th':'พอร์ทัลอีคอมเมิร์ซจะหยุดให้บริการเพื่อรับการบำรุงรักษาตามแผนตั้งแต่ ||@startdate ถึง @enddate. โปรดลองอีกครั้งในภายหลัง',
        'vi':'Cổng thương mại sẽ tạm dừng hoạt động để bảo trì theo kế hoạch từ ||@startdate đến @enddate. Vui lòng thử lại sau.',
        'ko':'전자상거래 포털은 유지보수를 위해 ||@startdate ~ @enddate 기간 동안 중단됩니다. 나중에 다시 시도하십시오.',
        'zh':'电子商务门户将从 ||@startdate 至 @enddate 关闭以进行计划内维护. 请稍后再试.',
        'it':'Il portale di e-commerce non sarà disponibile a causa di una manutenzione pianificata dal giorno ||@startdate al giorno @enddate. Riprova più tardi.',
        'hu':'Az e-kereskedelmi portál a tervezett karbantartások miatt nem lesz elérhető ||@startdate tól @enddate ig. Kérjük, próbálja meg később.',
        'pl':'Portal E-Commerce będzie nieaktywny z powodu konserwacji planowanej od ||@startdate do @enddate. Spróbuj ponownie później'
    },
    UnplannedOutageBannerMessageLoginAllowed : {
        //so far the business has not clearly stated cases where they would want users to still log in (such as when there is poor performance but not bad enough to prevent logins)
        //-- this is where they may just want to show some informational banner perhaps that is not "canned"
        //-- we do not have a way to let them enter custom banner text that is translated
        'en':'Guardian is experiencing a temporary technical issue on the E-Commerce Portal. The problems may affect performance. If you experience unacceptable wait times, please submit your requests via email until the issue is resolved.',
    },
    UnplannedOutageBannerMessageLoginNotAllowed : {
        'en':'We apologize. Guardian is experiencing a temporary technical issue on the E-Commerce Portal. Please submit your requests via email until the issue is resolved.',
        'fr':"Nous vous prions de nous excuser. Guardian rencontre un problème temporaire sur le portail d’e-commerce. Veuillez envoyer vos demandes par e-mail jusqu’à la résolution du problème.",
        'sp':'Le pedimos disculpas. Guardian está experimentando un problema temporal en el Portal de comercio electrónico. Envíe sus solicitudes por correo electrónico hasta que se resuelva el problema.',
        'gr':'Wir bitten um Entschuldigung. Guardian hat momentan ein Problem mit dem E-Commerce-Portal. Bitte senden Sie Ihre Anfragen per E-Mail, bis das Problem gelöst ist.',
        'por':'Desculpe o inconveniente. A Guardian está enfrentando um problema temporário no Portal de comércio eletrônico. Envie suas solicitações por e-mail até que o problema seja resolvido.',
		'pteu':"Pedimos desculpa. A Guardian está com problemas temporários no Portal de comércio eletrónico. Envie os seus pedidos por e-mail até que o problema seja resolvido.",
        'tur':'Özür diliyoruz. Guardian, E-ticaret Portalı’nda geçici bir sorun yaşıyor. Lütfen sorun çözülene kadar taleplerinizi e-posta aracılığıyla iletin.',
        'th':'ขออภัย. Guardian กำลังประสบปัญหาชั่วคราวในพอร์ทัลอีคอมเมิร์ซ. โปรดส่งคำขอของคุณทางอีเมลจนกว่าปัญหาดังกล่าวจะได้รับการแก้ไข.',
        'vi':'Chúng tôi rất tiếc. Cổng thương mại điện tử của Guardian đang gặp phải sự cố tạm thời. Vui lòng gửi yêu cầu của bạn qua email cho đến khi sự cố này được giải quyết.',
        'ko':'죄송합니다. Guardian은 전자상거래 포털에서 일시적인 문제를 겪고 있습니다. 문제가 해결될 때까지 이메일을 통해 요청을 제출하십시오.',
        'zh':'很抱歉。Guardian 电子商务门户遇到暂时性问题。请通过电子邮件提交您的请求，直至问题得到解决。',
        'it':'Ci scusiamo per il disagio. Guardian sta riscontrando un problema temporaneo sul portale di e-commerce. Invia le tue richieste via e-mail fino a quando non risolveremo il problema.',
        'hu':'Elnézést kérünk. A Guardian átmeneti problémát tapasztal az e-kereskedelmi portálon. Kérjük, küldje el a kéréseit e-mailben, amíg a probléma meg nem oldódik.',
        'pl':"Przepraszamy. Na Portalu E-commerce firmy Guardian wystąpiły problemy. Do momentu ich rozwiązania wnioski należy przesyłać pocztą e-mail."
    },
    NotificationBannerMessage: {
        'en':'Important Notice: The E-Commerce Portal will be down for planned maintenance from ||@startdate to @enddate.',
        'fr':'Note importante: Le portail d’e-commerce sera indisponible pour une maintenance planifiée du ||@startdate au @enddate.',
        'sp':'Aviso importante: El portal de comercio electrónico estará fuera de servicio por mantenimiento planificado desde el ||@startdate hasta el @enddate.',
        'gr':'Wichtiger Hinweis: Das E-Commerce-Portal ist wegen geplanter Wartungsarbeiten von ||@startdate bis @enddate nicht erreichbar.',
        'por':'Aviso importante: O Portal de comércio eletrônico permanecerá fora do ar para manutenção planejada de ||@startdate a @enddate.',
		'pteu':"Aviso importante: O Portal de comércio eletrónico ficará inativo para manutenção planeada de ||@startdate a @enddate.",
        'tur':'Önemli uyarı: E-Ticaret Portalı, planlı bakım için ||@startdate ila @enddate arasında servis dışı olacaktır',
        'th':'ประกาศสำคัญ: พอร์ทัลอีคอมเมิร์ซจะหยุดให้บริการเพื่อรับการบำรุงรักษาตามแผนตั้งแต่ ||@startdate ถึง @enddate',
        'vi':'Thông báo quan trọng: Cổng thương mại sẽ tạm dừng hoạt động để bảo trì theo kế hoạch từ ||@startdate đến @enddate.',
        'ko':'중요 알림: 전자상거래 포털은 유지보수를 위해 ||@startdate ~ @enddate 기간 동안 중단됩니다.',
        'zh':'重要说明: 电子商务门户将从 ||@startdate 至 @enddate 关闭以进行计划内维护',
        'it':'Avviso importante: Il portale di e-commerce non sarà disponibile a causa di una manutenzione pianificata dal giorno ||@startdate al giorno @enddate.',
        'hu':'Fontos megjegyzés: Az e-kereskedelmi portál a tervezett karbantartások miatt nem lesz elérhető ||@startdate tól @enddate ig.',
        'pl':'Ważna uwaga: Portal E-Commerce będzie nieaktywny z powodu konserwacji planowanej od ||@startdate do @enddate.'
    },
    RegionalNotificationBannerMessage: {
        'en':'Important Notice: The E-Commerce Portal will be down in your region for planned maintenance from ||@startdate to @enddate.',
        'fr':'Note importante: Le portail d’e-commerce sera indisponible dans votre région pour une maintenance planifiée du ||@startdate au @enddate.',
        
        //TODO below have not been changed from non-regional version
        'sp':'Aviso importante: El portal de comercio electrónico estará fuera de servicio por mantenimiento planificado desde el ||@startdate hasta el @enddate.',
        'gr':'Wichtiger Hinweis: Das E-Commerce-Portal ist wegen geplanter Wartungsarbeiten von ||@startdate bis @enddate nicht erreichbar.',
        'por':'Aviso importante: O Portal de comércio eletrônico permanecerá fora do ar para manutenção planejada de ||@startdate a @enddate.',
		'pteu':"Aviso importante: O Portal de comércio eletrónico ficará inativo para manutenção planeada de ||@startdate a @enddate.",
        'tur':'Önemli uyarı: E-Ticaret Portalı, planlı bakım için ||@startdate ila @enddate arasında servis dışı olacaktır',
        'th':'ประกาศสำคัญ: พอร์ทัลอีคอมเมิร์ซจะหยุดให้บริการเพื่อรับการบำรุงรักษาตามแผนตั้งแต่ ||@startdate ถึง @enddate',
        'vi':'Thông báo quan trọng: Cổng thương mại sẽ tạm dừng hoạt động để bảo trì theo kế hoạch từ ||@startdate đến @enddate.',
        'ko':'중요 알림: 전자상거래 포털은 유지보수를 위해 ||@startdate ~ @enddate 기간 동안 중단됩니다.',
        'zh':'重要说明: 电子商务门户将从 ||@startdate 至 @enddate 关闭以进行计划内维护',
        'it':'Avviso importante: Il portale di e-commerce non sarà disponibile a causa di una manutenzione pianificata dal giorno ||@startdate al giorno @enddate.',
        'hu':'Fontos megjegyzés: Az e-kereskedelmi portál a tervezett karbantartások miatt nem lesz elérhető ||@startdate tól @enddate ig.',
        'pl':'Ważna uwaga: Portal E-Commerce będzie nieaktywny z powodu konserwacji planowanej od ||@startdate do @enddate.'
    },
    SignUpLabels: {
        'en':'Sign Up',
        'fr':"S'inscrire",
        'sp':'Regístrese',
        'gr':'Anmelden',
        'por':'Registre-se',
		'pteu':"Registo",
        'tur':'Kaydol',
        'th':'ลงทะเบียน',
        'vi':'Đăng ký',
        'ko':'가입',
        'zh':'注册',
        'ru':'Зарегистрироваться',    
        'it':'Registrati',
        'hu':'Regisztráció',
        'pl':'Zarejestruj się na stronie'
    }, 
    UserNameLabels: {
        'en':'Username',
        'fr':"Nom d'utilisateur",
        'sp':'Nombre de usuario',
        'gr':'Benutzername',
        'por':'Nome de usuário',
		'pteu':"Nome de utilizador:",
        'tur':'Kullanıcı Adı',
        'th':'ชื่อผู้ใช้',
        'vi':'tên tài khoản',
        'ko':'사용자 이름',
        'zh':'用户名（Username）',
        'ru':'Имя пользователя',    
        'it':'Nome utente',
        'hu':'Felhasználónév',
        'pl':'Nazwa użytkownika'
    },
    PasswordLabels:{
        'en':'Password',
        'fr':"Mot de passe",
        'sp':'Contraseña',
        'gr':'Kennwort',
        'por':'Senha',
		'pteu':"Palavra-passe",
        'tur':'Parola',
        'th':'รหัสผ่าน',
        'vi':'Mật khẩu',
        'ko':'비밀번호',
        'zh':'密码 （Password）',
        'ru':'Пароль',    
        'it':'Password',
        'hu':'Jelszó',
        'pl':'Hasło'
    },
    ConfirmNewPasswordLabels: {
        'en':'Confirm New Password',
        'fr':"Confirmer le nouveau mot de passe",
        'sp':'Confirmar la nueva contraseña',
        'gr':'Neues Passwort bestätigen',
        'por':'Confirmar nova senha',
		'pteu':"Confirmar nova palavra-passe",
        'tur':'Yeni Parolayı Onayla',
        'th':'ยืนยันรหัสผ่านใหม่',
        'vi':'Xác nhận mật khẩu mới',
        'ko':'새 비밀번호를 확인합니다.',
        'zh':'确认新密码',
        'ru':'Подтвердите новый пароль',    
        'it':'Conferma la nuova password',
        'hu':'Új jelszó megerősítése',
        'pl':'Potwierdź nowe hasło'
    },
    ResetPasswordLabels: {
        'en':'Reset Password',
        'fr':'Réinitialiser le mot de passe',
        'sp':'Restablecer contraseña',
        'gr':'Passwort zurücksetzen',
        'por':'Redefinir senha',
		'pteu':"Repor palavra-passe",
        'tur':'Parolayı Sıfırla',
        'th':'รีเซ็ตรหัสผ่าน',
        'vi':'Đặt lại mật khẩu',
        'ko':'비밀번호 재설정하기',
        'zh':'重置密码',
        'ru':'Сброс пароля',    
        'it':'Reimposta la password',
        'hu':'Jelszó visszaállítása',
        'pl':'Zresetuj hasło'
    },
    NewPasswordLabels: {
        'en':'New Password',
        'fr':"Nouveau mot de passe",
        'sp':'Nueva contraseña',
        'gr':'Neues Passwort',
        'por':'Nova senha',
		'pteu':"Nova palavra-passe",
        'tur':'Yeni Parola',
        'th':'รหัสผ่านใหม่',
        'vi':'mật khẩu mới',
        'ko':'새 비밀번호',
        'zh':'新密码（New Password）',
        'ru':'Новый пароль',    
        'it':'Nuova password',
        'hu':'Új jelszó',
        'pl':'Nowe hasło'
    },
    SignInLabels: {
        'en':'Sign In',
        'fr':"Se connecter",
        'sp':'Iniciar sesión',
        'gr':'Anmeldung',
        'por':'Digite',
		'pteu':"Iniciar sessão",
        'tur':'Giriş Yap',
        'th':'เข้าสู่ระบบ',
        'vi':'Đăng nhập',
        'ko':'로그인',
        'zh':'登录',
        'ru':'Войти',    
        'it':'Accedi',
        'hu':'Belépés',
        'pl':'Zaloguj się'
    },
    NextButtonLabels: {
        'en':'Next',
        'fr':"Suivant",
        'sp':'Siguiente',
        'gr':'Weiter',
        'por':'Avançar',
		'pteu':"Seguinte",
        'tur':'İleri',
        'th':'ต่อไป',
        'vi':'Tiếp theo',
        'ko':'다음',
        'zh':'下一步',   
        'it':'Avanti',
        'hu':'Tovább',
        'pl':'Dalej'
    },
    LogInLabels: {
        'en':'Guardian Commerce Portal Login',
        'fr':"Connexion au portail Guardian Commerce",
        'sp':'Inicio de sesión del Portal de Comercio electrónico Guardian',
        'gr':'Anmeldung zum Guardian Commerce Portal',
        'por':'Login no Portal Guardian Commerce',
		'pteu':"Início de sessão no Portal E-Commerce da Guardian",
        'tur':'Guardian Commerce Portal Girişi',
        'th':'พอร์ทัลพาณิชย์ Guardian เข้าสู่ระบบ',
        'vi':'Đăng nhập Cổng thương mại Guardian',
        'ko':'Guardian Commerce Portal 로그인',
        'zh':'Guardian 商务门户网站登录',
        'ru':'Вход на Портал Guardian',    
        'it':'Accesso al portale Guardian Commerce',
        'hu':'Guardian kereskedelmi portál bejelentkezés',
        'pl':'Logowanie do portalu Guardian Commerce'
    },
    WelcomeNewUserLabels: {
        'en':'Welcome to Guardian Commerce Portal!',
        'fr':"Bienvenue sur le portail de commerce Guardian !",
        'sp':'Inicio de sesión del Portal de Comercio electrónico Guardian!',
        'gr':'Willkommen beim Guardian E-Commerce Portal!',
        'por':'Bem-vindo ao Portal Guardian Commerce!',
		'pteu':"Bem-vindo ao Portal E-Commerce da Guardian!",
        'tur':'Guardian Commerce Portal’a Hoş Geldiniz!',
        'th':'ยินดีต้อนรับสู่ Portal Commerce!',
        'vi':'Chào mừng bạn đến với Cổng thương mại Guardian!',
        'ko':'Guardian Commerce 포털에 오신 것을 환영합니다!',
        'zh':'欢迎访问Guardian商务门户网站!',
        'ru':'Добро пожаловать на Портал Guardian!',    
        'it':'Benvenuti nel portale Guardian Commerce!',
        'hu':'Üdvözöljük a Guardian kereskedelmi portálon!',
        'pl':'Witamy w portalu Guardian Commerce!'
    },
    PasswordHintLabels: {
        'en':'Passwords must contain at least eight characters, numbers, special characters, uppercase letter and lowercase letter.',
        'fr':"Les mots de passe doivent contenir au moins huit caractères, des chiffres, des caractères spéciaux, une lettre majuscule et une lettre minuscule.",
        'sp':'Las contraseñas deben contener al menos ocho caracteres, números, caracteres especiales, letras mayúsculas y minúsculas.',
        'gr':'Passwörter müssen mindestens acht Zeichen, Zahlen, Sonderzeichen, Groß- und Kleinbuchstaben enthalten.',
        'por':'As senhas devem conter pelo menos oito caracteres, números, caracteres especiais, letras maiúsculas e minúsculas.',
		'pteu':"As palavras-passe devem conter, pelo menos, oito caracteres, números, caracteres especiais, letras maiúsculas e minúsculas.",
        'tur':'Parolalar en az sekiz karakterden oluşmalı ve rakam, özel karakter, büyük ve küçük harf içermelidir.',
        'th':'รหัสผ่านจำเป็นต้องมีจำนวนอย่างน้อย8ตัว โดยประกอบด้วยเครื่องหมาย ตัวอักษรใหญ่ และตัวอักษรเล็ก',
        'vi':'Mật khẩu phải chứa ít nhất tám ký tự, số, ký tự đặc biệt, chữ hoa và chữ thường.',
        'ko':'비밀번호는 8자 이상이어야 하며 숫자, 특수 문자, 대문자 및 소문자를 포함해야 합니다.',
        'zh':'密码必须至少包含八个字符、数字、特殊字符、大写字母和小写字母。',
        'ru':'Пароль должен содержать не менее восьми символов, цифры, специальные символы, заглавные и строчные буквы.',    
        'it':'Le password devono contenere almeno otto caratteri, numeri, caratteri speciali, lettere maiuscole e minuscole.',
        'hu':'A jelszónak legalább nyolc karaktert, számokat, speciális karaktereket, nagy- és kisbetűket kell tartalmaznia.',
        'pl':'Hasło musi zawierać co najmniej osiem znaków, cyfry, znaki specjalne, duże i małe litery.'
    },
    ForgotPasswordHintLabels: {
        'en':'Please contact a Guardian Administrator if you forgot your password.',
        'fr':"Veuillez contacter un administrateur de Guardian si vous avez oublié votre mot de passe.",
        'sp':'Por favor, póngase en contacto con un administrador de Guardian si no recuerda su contraseña.',
        'gr':'Bitte wenden Sie sich an einen Guardian-Administrator, wenn Sie Ihr Passwort vergessen haben.',
        'por':'Favor entrar em contato com um Administrador Guardian se você tiver esquecido sua senha.',
		'pteu':"Contacte um Administrador Guardian caso se tenha esquecido da sua palavra-passe.",
        'tur':'Parolanızı unuttuysanız lütfen bir Guardian Yöneticisiyle iletişime geçin.',
        'th':'กรุณาติดต่อผู้ดูแลระบบ หากคุณลืมรหัสผ่าน',
        'vi':'Vui lòng liên hệ với Quản trị viên Guardian nếu bạn quên mật khẩu của mình.',
        'ko':'비밀번호를 잊은 경우 Guardian 관리자에게 문의하십시오.',
        'zh':'如果您忘记密码,请联系Guardian管理员。',
        'ru':'Если вы забыли свой пароль, обратитесь к администратору Guardain.',    
        'it':'Si prega di contattare un Amministratore Guardian se si è dimenticata la password.',
        'hu':'Kérjük, forduljon egy rendszergazda-őrhöz, ha elfelejtette jelszavát.',
        'pl':'Jeśli nie pamiętasz hasła, skontaktuj się z z Administratorem Guardiana'
    },
    ForgotPasswordLabels: {
        'en':'Forgot your password?',
        'fr':"Vous avez oublié votre mot de passe?",
        'sp':'¿Ha olvidado su contraseña?',
        'gr':'Haben Sie Ihr Kennwort vergessen?',
        'por':'Esqueceu sua senha?',
		'pteu':"Esqueceu-se da sua palavra-passe?",
        'tur':'Parolanızı mı unuttunuz?',
        'th':'ลืมรหัสผ่าน?',
        'vi':'Quên giấy tờ tùy thân của bạn?',
        'ko':'비밀번호를 잊으셨습니까?',
        'zh':'忘记你的通行证了吗？',
        'ru':'Забыли пароль?',    
        'it':'Hai dimenticato la tua password?',
        'hu':'Elfelejtette a jelszavát?',
        'pl':'Zapomniałeś hasła?'
    },
ErroMessages: {
    'en':{
		'InternalErrorException': 'There is an internal error. Please try later.',
		'UserNotFoundException':'User does not exist.',
		'NotAuthorizedException':'Incorrect username or password.',
		'UserNotConfirmedException':'There is a problem with your account. Please contact @emailId for assistance.',
		'ExpiredCodeException':'Temporary password has expired and must be reset by an administrator.',
		'UserIsDisabledException':'User is disabled and must be enabled by administration.',
		'PasswordPolicyException':'Passwords must contain at least eight characters, numbers, special characters, uppercase letter and lowercase letter.',
		'ConfirmPasswordNotMatchException':'Password and confirm password must match.',
		'ValidateUserNameAndPassword':'Username and password are required.',
		'InvalidCodeException':'Invalid verification code provided, please try again.',
		'InvalidSessionForUserException':'Invalid session for the user, session is expired. Please logged in again.',
		'Invalid session for the user.':'Your session has expired. Please start the login process again.',
		'ValidateUserName':'Username is required.',
		'TooManyRequestsException':'Number of access attempts is exceeded, please re-try after 30 minutes.',
		'InvalidUsername':'Username should be between 1 and 128 characters in length and can not contain any white space.',
        'InvalidPasswordException':"Passwords must contain at least eight characters, numbers, special characters, uppercase letter and lowercase letter.",

        'User does not have delivery config set to turn on SOFTWARE_TOKEN_MFA': 'Please click "Register App" and complete the registration before enabling Authenticator App',

        'MFAREQUIRED':"You must select either SMS, Auth APP, or Email",
        'AliasExistsException':"This exception is thrown when a user tries to confirm the account with an email address or phone number that has already been supplied as an alias for a different user profile. This exception indicates that an account with this email address or phone already exists in a user pool that you've configured to use email address or phone number as a sign-in alias.",
        'CodeMismatchException':"Invalid verification code. Please check the code and try again.",
        'ForbiddenException':"This exception is thrown when AWS WAF doesn't allow your request based on a web ACL that's associated with your user pool.",
        'InvalidLambdaResponseException':"This exception is thrown when Amazon Cognito encounters an invalid AWS Lambda response.",
        'InvalidParameterException':"This exception is thrown when the Amazon Cognito service encounters an invalid parameter.",
        'InvalidSmsRoleAccessPolicyException':"This exception is returned when the role provided for SMS configuration doesn't have permission to publish using Amazon SNS.",
        'InvalidSmsRoleTrustRelationshipException':"This exception is thrown when the trust relationship is not valid for the role provided for SMS configuration. This can happen if you don't trust cognito-idp.amazonaws.com or the external ID provided in the role does not match what is provided in the SMS configuration for the user pool.",
        'InvalidUserPoolConfigurationException':"This exception is thrown when the user pool configuration is not valid.",
        'MFAMethodNotFoundException':"This exception is thrown when Amazon Cognito can't find a multi-factor authentication (MFA) method.",
        "PasswordResetRequiredException":"This exception is thrown when a password reset is required.",
        "ResourceNotFoundException":"This exception is thrown when the Amazon Cognito service can't find the requested resource.",
        "SoftwareTokenMFANotFoundException":"This exception is thrown when the software token time-based one-time password (TOTP) multi-factor authentication (MFA) isn't activated for the user pool.",
        "UnexpectedLambdaException":"This exception is thrown when Amazon Cognito encounters an unexpected exception with AWS Lambda.",
        "UserLambdaValidationException":"This exception is thrown when the Amazon Cognito service encounters a user validation exception with the AWS Lambda service.",
        "LimitExceededException":"This exception is thrown when a user exceeds the limit for a requested AWS resource.",
        "TooManyFailedAttemptsException":"This exception is thrown when the user has made too many failed attempts for a given action, such as sign-in.",
        "CodeDeliveryFailureException":"This exception is thrown when a verification code fails to deliver successfully.",
        "InvalidEmailRoleAccessPolicyException":"This exception is thrown when Amazon Cognito isn't allowed to use your email identity. HTTP status code: 400.",
        "ConcurrentModificationException":"This exception is thrown if two or more modifications are happening concurrently.",
        "EnableSoftwareTokenMFAException":"This exception is thrown when there is a code mismatch and the service fails to configure the software token TOTP multi-factor authentication (MFA).",
        
    },
	'fr':{
        'InternalErrorException': "Il y a une erreur interne, veuillez essayer plus tard.",
		'UserNotFoundException':"L'utilisateur n'existe pas.",
		'NotAuthorizedException':"Nom d'utilisateur ou mot de passe incorrect.",
		'UserNotConfirmedException':"Il y a un problème avec votre compte. Veuillez contacter @emailId pour obtenir de l'aide.",
		'ExpiredCodeException':'Le mot de passe temporaire a expiré et doit être réinitialisé par un administrateur.',
		'UserIsDisabledException':"L'utilisateur est désactivé et doit être activé par l'administration.",
		'PasswordPolicyException':'Les mots de passe doivent contenir au moins huit caractères, des chiffres, des caractères spéciaux, une lettre majuscule et une lettre minuscule.',
		'ConfirmPasswordNotMatchException':'Le mot de passe et le mot de passe de confirmation doivent correspondre.',
		'ValidateUserNameAndPassword':"Le nom d'utilisateur et le mot de passe sont requis.",
		'InvalidCodeException':'Code de vérification fourni non valide, veuillez réessayer.'            ,
		'InvalidSessionForUserException':"Session non valide pour l'utilisateur, la session a expiré. Veuillez vous reconnecter.",
		'Invalid session for the user.':"Votre session a expiré. Veuillez recommencer le processus de connexion.",
		'ValidateUserName':"Le nom de l'utilisateur est requis.",
		'TooManyRequestsException':"Le nombre de tentatives d'accès est dépassé, veuillez réessayer après 30 minutes.",
		'InvalidUsername':"Le nom d'utilisateur doit comporter entre 1 et 128 caractères et ne doit pas contenir d'espace.",
        'InvalidPasswordException':'Les mots de passe doivent contenir au moins huit caractères, des chiffres, des caractères spéciaux, une lettre majuscule et une lettre minuscule.',

        'MFAREQUIRED':"Vous devez sélectionner soit SMS, soit application d’authentification",
        'AliasExistsException':"Cette exception se produit lorsqu’un utilisateur tente de confirmer le compte avec une adresse e-mail ou un numéro de téléphone qui a déjà été fourni en tant qu’alias pour un autre profil d’utilisateur  Cette exception indique qu’un compte avec cette adresse e-mail ou ce numéro de téléphone existe déjà dans un groupe d’utilisateurs que vous avez configuré pour utiliser l’adresse e-mail ou le numéro de téléphone en tant qu’alias de connexion.",
        'CodeMismatchException':"Code de vérification invalide. Veuillez vérifier le code et réessayer.",
        'ForbiddenException':"Cette exception se produit lorsque AWS WAF n’autorise pas votre demande sur la base d’une ACL Web associée à votre groupe d’utilisateurs.",
        'InvalidLambdaResponseException':"Cette exception se produit lorsque Amazon Cognito rencontre une réponse AWS Lambda invalide.",
        'InvalidParameterException':"Cette exception se produit lorsque le service Amazon Cognito rencontre un paramètre invalide.",
        'InvalidSmsRoleAccessPolicyException':"Cette exception est renvoyée lorsque le rôle fourni pour la configuration SMS ne dispose pas de l’autorisation de publier à l’aide d’Amazon SNS.",
        'InvalidSmsRoleTrustRelationshipException':"Cette exception se produit lorsque la relation de confiance n’est pas valide pour le rôle fourni pour la configuration SMS. Cela peut se produire si vous ne faites pas confiance à cognito-idp.amazonaws.com ou si l’ID externe fourni dans le rôle ne correspond pas à ce qui est fourni dans la configuration SMS pour le groupe d’utilisateurs.",
        'InvalidUserPoolConfigurationException':"Cette exception se produit lorsque la configuration du groupe d’utilisateurs n’est pas valide.",
        'MFAMethodNotFoundException':"Cette exception se produit lorsque Amazon Cognito ne trouve pas une méthode d’authentification multifactorielle (MFA).",
        "PasswordResetRequiredException":"Cette exception se produit lorsqu’une réinitialisation du mot de passe est requise.",
        "ResourceNotFoundException":"Cette exception se produit lorsque le service Amazon Cognito ne trouve pas la ressource demandée.",
        "SoftwareTokenMFANotFoundException":"Cette exception se produit lorsque l’authentification multifactorielle (MFA) par mot de passe à usage unique (TOTP) basée sur le jeton logiciel n’est pas activée pour le groupe d’utilisateurs.",
        "UnexpectedLambdaException":"Cette exception se produit lorsque Amazon Cognito rencontre une exception inattendue avec AWS Lambda.",
        "UserLambdaValidationException":"Cette exception se produit lorsque le service Amazon Cognito rencontre une exception de validation d’utilisateur avec le service AWS Lambda.",
        "LimitExceededException":"Cette exception se produit lorsqu’un utilisateur dépasse la limite d’une ressource AWS demandée.",
        "TooManyFailedAttemptsException":"Cette exception se produit lorsque l’utilisateur a fait trop de tentatives échouées pour une action donnée, telle que la connexion.",
        "CodeDeliveryFailureException":"Cette exception se produit lorsqu’un code de vérification n’est pas délivré avec succès.",
        "InvalidEmailRoleAccessPolicyException":"Cette exception se produit lorsque Amazon Cognito n’est pas autorisé à utiliser votre identité e-mail. Code de statut HTTP : 400.",
        "ConcurrentModificationException":"Cette exception se produit si deux ou plusieurs modifications ont lieu simultanément.",
        "EnableSoftwareTokenMFAException":"Cette exception se produit en cas de discordance de code et lorsque le service ne parvient pas à configurer l’authentification multifactorielle (MFA) TOTP du jeton logiciel.",
        
     },
	 'sp':{
        'InternalErrorException': "Hay un error interno, por favor intente más tarde.",
		'UserNotFoundException':"El usuario no existe.",
		'NotAuthorizedException':'Nombre de usuario o contraseña incorrecta.',
		'UserNotConfirmedException':"Hay un problema con su cuenta. Por favor, póngase en contacto con @emailId para obtener ayuda.",
		'ExpiredCodeException':'La contraseña temporal ha caducado y debe ser restablecida por un administrador.',
		'UserIsDisabledException':"El usuario está deshabilitado y debe ser habilitado por la administración.",
        'PasswordPolicyException':'Las contraseñas deben contener al menos ocho caracteres, números, caracteres especiales, letras mayúsculas y minúsculas.',
		'ConfirmPasswordNotMatchException':'La contraseña y la contraseña de confirmación deben coincidir.',
		'ValidateUserNameAndPassword':"El nombre de usuario y la contraseña son necesarios.",
		'InvalidCodeException':'Se proporcionó un código de verificación no válido, inténtelo de nuevo.',
		'InvalidSessionForUserException':'Sesión inválida para el usuario, la sesión ha caducado. Por favor, inicie la sesión de nuevo.',
		'Invalid session for the user.':'Su sesión ha expirado. Por favor, inicie el proceso de inicio de sesión nuevamente.',
		'ValidateUserName':"El nombre de usuario es necesario.",
		'TooManyRequestsException':'Se ha superado el número de intentos de acceso, vuelva a intentarlo después de 30 minutos.',
		'InvalidUsername':"El nombre de usuario debe tener entre 1 y 128 caracteres y no puede contener espacios en blanco.",
        'InvalidPasswordException':'Las contraseñas deben contener al menos ocho caracteres, números, caracteres especiales, letras mayúsculas y minúsculas.',

        'MFAREQUIRED':"Debe seleccionar SMS o aplicación de autentificación",
        'AliasExistsException':"Esta excepción se produce cuando un usuario intenta confirmar la cuenta con una dirección de correo electrónico o número de teléfono que ya se ha proporcionado como alias para un perfil de usuario diferente. Esta excepción indica que ya existe una cuenta con esta dirección de correo electrónico o teléfono en un grupo de usuarios que ha configurado para utilizar la dirección de correo electrónico o el número de teléfono como alias de inicio de sesión.",
        'CodeMismatchException':"Código de verificación no válido. Por favor, verifique el código e inténtelo de nuevo.",
        'ForbiddenException':"Esta excepción se produce cuando AWS WAF no permite su solicitud basada en una ACL web asociada a su grupo de usuarios.",
        'InvalidLambdaResponseException':"Esta excepción se produce cuando Amazon Cognito encuentra una respuesta AWS Lambda no válida.",
        'InvalidParameterException':"Esta excepción se produce cuando el servicio de Amazon Cognito encuentra un parámetro no válido.",
        'InvalidSmsRoleAccessPolicyException':"Esta excepción se produce cuando la función proporcionada para la configuración de SMS no tiene permiso para publicar utilizando Amazon SNS.",
        'InvalidSmsRoleTrustRelationshipException':"Esta excepción se produce cuando la relación de confianza no es válida para el rol proporcionado para la configuración de SMS. Esto puede suceder si no confía en cognito-idp.amazonaws.com o si el ID externo proporcionado en la función no coincide con lo que se proporciona en la configuración de SMS para el grupo de usuarios.",
        'InvalidUserPoolConfigurationException':"Esta excepción se produce cuando la configuración del grupo de usuarios no es válida.",
        'MFAMethodNotFoundException':"Esta excepción se produce cuando Amazon Cognito no puede encontrar un método de autenticación multifactor (MFA).",
        "PasswordResetRequiredException":"Esta excepción se produce cuando se requiere un restablecimiento de contraseña.",
        "ResourceNotFoundException":"Esta excepción se produce cuando el servicio de Amazon Cognito no puede encontrar el recurso solicitado.",
        "SoftwareTokenMFANotFoundException":"Esta excepción se produce cuando la autenticación multifactor (MFA) de contraseña de un solo uso basada en el tiempo (TOTP) del token de software no está activada para el grupo de usuarios.",
        "UnexpectedLambdaException":"Esta excepción se produce cuando Amazon Cognito encuentra una excepción inesperada con AWS Lambda.",
        "UserLambdaValidationException":"Esta excepción se produce cuando el servicio Amazon Cognito encuentra una excepción de validación de usuario con el servicio AWS Lambda.",
        "LimitExceededException":"Esta excepción se produce cuando un usuario supera el límite de un recurso de AWS solicitado.",
        "TooManyFailedAttemptsException":"Esta excepción se produce cuando el usuario ha realizado demasiados intentos fallidos para una acción determinada, como el inicio de sesión.",
        "CodeDeliveryFailureException":"Esta excepción se produce cuando un código de verificación no se entrega correctamente.",
        "InvalidEmailRoleAccessPolicyException":"Esta excepción se produce cuando Amazon Cognito no tiene permiso para usar su identidad de correo electrónico. Código de estado HTTP: 400.",
        "ConcurrentModificationException":"Esta excepción se produce si hay dos o más modificaciones simultáneamente.",
        "EnableSoftwareTokenMFAException":"Esta excepción se produce cuando hay una discrepancia de código y el servicio no puede configurar la autenticación multifactor (MFA) TOTP token de software.",
    },
	'gr':{
        'InternalErrorException': "Es ist ein interner Fehler aufgetreten, bitte versuchen Sie es später.",
		'UserNotFoundException':"Benutzer existiert nicht.",
		'NotAuthorizedException':'Falscher Benutzername oder falsches Passwort.',
		'UserNotConfirmedException':"Es gibt ein Problem mit Ihrem Konto. Bitte kontaktieren Sie @emailId für Hilfe.",
		'ExpiredCodeException':'Das temporäre Passwort ist abgelaufen und muss von einem Administrator zurückgesetzt werden.',
		'UserIsDisabledException':"Der Benutzer ist deaktiviert und muss von der Verwaltung aktiviert werden.",
        'PasswordPolicyException':'Passwörter müssen mindestens acht Zeichen, Zahlen, Sonderzeichen, Großbuchstaben und Kleinbuchstaben enthalten.',
		'ConfirmPasswordNotMatchException':'Passwort und Bestätigungspasswort müssen übereinstimmen.',
		'ValidateUserNameAndPassword':"Benutzername und Passwort sind erforderlich.",
		'InvalidCodeException':'Code ist nicht gültig. Bitte versuchen Sie es erneut.',
		'InvalidSessionForUserException':'Ungültige Sitzung für den Benutzer, die Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
		'Invalid session for the user.':'Ihre Sitzung ist abgelaufen. Bitte starten Sie den Anmeldevorgang erneut.',
		'ValidateUserName':"Benutzername ist erforderlich.",
		'TooManyRequestsException':'Die Anzahl der Zugriffsversuche ist überschritten. Bitte versuchen Sie es nach 30 Minuten erneut.',
		'InvalidUsername':"Der Benutzername sollte zwischen 1 und 128 Zeichen lang sein und darf keine Leerzeichen enthalten.",
        'InvalidPasswordException':'Passwörter müssen mindestens acht Zeichen, Zahlen, Sonderzeichen, Großbuchstaben und Kleinbuchstaben enthalten.',

        'MFAREQUIRED':"Sie müssen entweder SMS oder Auth APP auswählen",
        'AliasExistsException':"Diese Ausnahme wird ausgelöst, wenn ein Benutzer versucht, das Konto mit einer E-Mail-Adresse oder Telefonnummer zu bestätigen, die bereits als Alias für ein anderes Benutzerprofil angegeben wurde. Diese Ausnahme gibt an, dass ein Konto mit dieser E-Mail-Adresse oder diesem Telefon bereits in einem Benutzer-Pool vorhanden ist, den Sie für die Verwendung der E-Mail-Adresse oder Telefonnummer als Anmelde-Alias konfiguriert haben.",
        'CodeMismatchException':"Ungültiger Bestätigungscode. Bitte überprüfen Sie den Code und versuchen Sie es erneut.",
        'ForbiddenException':"Diese Ausnahme wird ausgelöst, wenn AWS-WAF Ihre Anfrage basierend auf einer Web-ACL, die Ihrem Benutzer-Pool zugeordnet ist, nicht zulässt.",
        'InvalidLambdaResponseException':"Diese Ausnahme wird ausgelöst, wenn Amazon Cognito auf eine ungültige AWS-Lambda-Antwort stößt.",
        'InvalidParameterException':"Diese Ausnahme wird ausgelöst, wenn der Amazon-Cognito-Service auf einen ungültigen Parameter stößt.",
        'InvalidSmsRoleAccessPolicyException':"Diese Ausnahme wird zurückgegeben, wenn die für die SMS-Konfiguration bereitgestellte Rolle nicht über die Berechtigung zum Veröffentlichen mit Amazon SNS verfügt.",
        'InvalidSmsRoleTrustRelationshipException':"Diese Ausnahme wird ausgelöst, wenn die Vertrauensstellung für die für die SMS-Konfiguration bereitgestellte Rolle nicht gültig ist. Dies kann vorkommen, wenn Sie cognito-idp.amazonaws.com nicht vertrauen oder die in der Rolle bereitgestellte externe ID nicht mit der in der SMS-Konfiguration für den Benutzer-Pool angegebenen übereinstimmt.",
        'InvalidUserPoolConfigurationException':"Diese Ausnahme wird ausgelöst, wenn die Konfiguration des Benutzer-Pools ungültig ist.",
        'MFAMethodNotFoundException':"Diese Ausnahme wird ausgelöst, wenn Amazon Cognito keine Multi-Faktor-Authentifizierungsmethode (MFA) finden kann.",
        "PasswordResetRequiredException":"Diese Ausnahme wird ausgelöst, wenn ein Zurücksetzen des Passworts erforderlich ist.",
        "ResourceNotFoundException":"Diese Ausnahme wird ausgelöst, wenn der Amazon-Cognito-Service die angeforderte Ressource nicht finden kann.",
        "SoftwareTokenMFANotFoundException":"Diese Ausnahme wird ausgelöst, wenn die Multi-Faktor-Authentifizierung (MFA) für das zeitbasierte Einmalpasswort (TOTP) des Software-Tokens für den Benutzer-Pool nicht aktiviert ist.",
        "UnexpectedLambdaException":"Diese Ausnahme wird ausgelöst, wenn Amazon Cognito auf eine unerwartete Ausnahme mit AWS Lambda stößt.",
        "UserLambdaValidationException":"Diese Ausnahme wird ausgelöst, wenn der Amazon-Cognito Service auf eine Ausnahme bei der Benutzervalidierung mit dem AWS-Lambda-Service stößt.",
        "LimitExceededException":"Diese Ausnahme wird ausgelöst, wenn ein Benutzer das Limit für eine angeforderte AWS-Ressource überschreitet.",
        "TooManyFailedAttemptsException":"Diese Ausnahme wird ausgelöst, wenn der Benutzer zu viele fehlgeschlagene Versuche für eine bestimmte Aktion, z. B. die Anmeldung, unternommen hat.",
        "CodeDeliveryFailureException":"Diese Ausnahme wird ausgelöst, wenn ein Verifizierungscode nicht erfolgreich zugestellt werden kann.",
        "InvalidEmailRoleAccessPolicyException":"Diese Ausnahme wird ausgelöst, wenn Amazon Cognito Ihre E-Mail-Identität nicht verwenden darf. HTTP-Statuscode: 400.",
        "ConcurrentModificationException":"Diese Ausnahme wird ausgelöst, wenn zwei oder mehr Änderungen gleichzeitig stattfinden.",
        "EnableSoftwareTokenMFAException":"Diese Ausnahme wird ausgelöst, wenn eine Code-Fehlanpassung vorliegt und der Service den Software-Token TOTP Multi-Faktor-Authentifizierung (MFA) nicht konfiguriert.",
    },
    'por':{
		'InternalErrorException': 'Há um erro interno, por favor tente novamente mais tarde.',
		'UserNotFoundException':'O usuário não existe.',
		'NotAuthorizedException':'Nome de usuário ou senha incorretos.',
		'UserNotConfirmedException':"Há um problema com sua conta. Favor contatar @emailId para assistência.",
		'ExpiredCodeException':'A senha temporária expirou e deve ser redefinida por um administrador.',
		'UserIsDisabledException':"O usuário está desabilitado e deve ser habilitado por admin.",
        'PasswordPolicyException':'As senhas devem conter pelo menos oito caracteres, números, caracteres especiais, letra maiúscula e letra minúscula.',
		'ConfirmPasswordNotMatchException':'A senha e a confirmação da senha devem corresponder.',
		'ValidateUserNameAndPassword':"Nome de usuário e senha necessários.",
		'InvalidCodeException':'Código de verificação inválido fornecido. Tente novamente.',
		'InvalidSessionForUserException':'Sessão inválida para o usuário, a sessão expirou. Por favor, faça o login novamente.',
		'ValidateUserName':"O nome do usuário é obrigatório.",
		'TooManyRequestsException':'O número de tentativas de acesso é excedido, favor tentar novamente após 30 minutos.',
		'InvalidUsername':"O nome de usuário deve ter entre 1 e 128 caracteres e não pode conter nenhum espaço em branco.",
        'InvalidPasswordException': 'As senhas devem conter pelo menos oito caracteres, números, caracteres especiais, letra maiúscula e letra minúscula.',
        
        'MFAREQUIRED':"É necessário selecionar SMS ou Aplicativo autenticador",
        'AliasExistsException':"Esta exceção é acionada quando um usuário tenta confirmar a conta com um endereço de e-mail ou número de telefone que já foi fornecido como um alias para um perfil de usuário diferente. Esta exceção indica que uma conta com esse endereço de e-mail ou telefone já existe em um pool de usuários que você configurou para usar o endereço de e-mail ou número de telefone como um alias de login.",
        'CodeMismatchException':"Código de verificação inválido. Por favor, verifique o código e tente novamente.",
        'ForbiddenException':"Esta exceção é acionada quando o AWS WAF não permite sua solicitação com base em uma ACL da Web associada ao seu pool de usuários.",
        'InvalidLambdaResponseException':"Esta exceção é acionada quando o Amazon Cognito encontra uma resposta inválida do AWS Lambda.",
        'InvalidParameterException':"Esta exceção é acionada quando o serviço Amazon Cognito encontra um parâmetro inválido.",
        'InvalidSmsRoleAccessPolicyException':"Esta exceção é retornada quando o perfil fornecido para configuração de SMS não tem permissão para publicar usando o Amazon SNS.",
        'InvalidSmsRoleTrustRelationshipException':"Esta exceção é acionada quando o relacionamento de confiança não é válido para o perfil fornecido para configuração de SMS. Isso poderá acontecer se você não confiar em cognito-idp.amazonaws.com ou se o ID externo fornecido no perfil não corresponder ao que é fornecido na configuração de SMS para o pool de usuários.",
        'InvalidUserPoolConfigurationException':"Esta exceção é acionada quando a configuração do pool de usuários não é válida.",
        'MFAMethodNotFoundException':"Esta exceção é acionada quando o Amazon Cognito não consegue encontrar um método de autenticação multifator (MFA).",
        "PasswordResetRequiredException":"Esta exceção é acionada quando uma redefinição de senha é necessária.",
        "ResourceNotFoundException":"Esta exceção é acionada quando o serviço Amazon Cognito não consegue encontrar o recurso solicitado.",
        "SoftwareTokenMFANotFoundException":"Esta exceção é acionada quando a autenticação multifator (MFA) de senha de uso único baseada em tempo (TOTP) do token de software não está ativada para o pool de usuários.",
        "UnexpectedLambdaException":"Esta exceção é acionada quando o Amazon Cognito encontra uma exceção inesperada com o AWS Lambda.",
        "UserLambdaValidationException":"Esta exceção é acionada quando o serviço Amazon Cognito encontra uma exceção de validação de usuário com o serviço AWS Lambda.",
        "LimitExceededException":"Esta exceção é acionada quando um usuário excede o limite para um recurso da AWS solicitado.",
        "TooManyFailedAttemptsException":"Esta exceção é acionada quando o usuário fez muitas tentativas com erro para uma determinada ação, por exemplo, login.",
        "CodeDeliveryFailureException":"Esta exceção é acionada quando um código de verificação não é entregue com êxito.",
        "InvalidEmailRoleAccessPolicyException":"Esta exceção é acionada quando o Amazon Cognito não tem permissão para usar sua identidade de e-mail. Código de status HTTP: 400.",
        "ConcurrentModificationException":"Esta exceção é acionada quando duas ou mais modificações são feitas ao mesmo tempo.",
        "EnableSoftwareTokenMFAException":"Esta exceção é acionada quando há uma incompatibilidade de código e o serviço falha ao configurar a autenticação multifator (MFA) de TOTP do token de software.",
    },
	'pteu':{
		'InternalErrorException': "Ocorreu um erro interno. Tente mais tarde.",
		'UserNotFoundException':"O utilizador não existe.",
		'NotAuthorizedException':"Nome de utilizador ou palavra-passe incorretos.",
		'UserNotConfirmedException':"Há um problema com a sua conta. Contacte @emailId para obter assistência.",
		'ExpiredCodeException':"A palavra-passe temporária expirou e tem de ser redefinida por um administrador.",
		'UserIsDisabledException':"O utilizador está desativado e tem de ser ativado pela administração.",
		'PasswordPolicyException':"As palavras-passe devem conter, pelo menos, oito caracteres, números, caracteres especiais, letras maiúsculas e minúsculas.",
		'ConfirmPasswordNotMatchException':"A palavra-passe e a palavra-passe de confirmação têm de corresponder.",
		'ValidateUserNameAndPassword':"São necessários o nome de utilizador e a palavra-passe.",
		'InvalidCodeException':"Código de verificação inválido fornecido, tente novamente.",
		'InvalidSessionForUserException':"Sessão inválida para o utilizador. A sessão expirou. Inicie sessão novamente.",
		'ValidateUserName':"O nome de utilizador é obrigatório.",
		'TooManyRequestsException':"O número de tentativas de acesso foi excedido, tente novamente após 30 minutos.",
		'InvalidUsername':"O nome de utilizador deve ter entre 1 e 128 caracteres e não pode conter qualquer espaço em branco.",
        'MFAREQUIRED':"Deve selecionar SMS ou APP Authenticator",
        'InvalidPasswordException':"As palavras-passe devem conter, pelo menos, oito caracteres, números, caracteres especiais, letras maiúsculas e minúsculas.",
		
		//'User does not have delivery config set to turn on SOFTWARE_TOKEN_MFA': 

        'AliasExistsException':"Esta exceção é acionada quando um utilizador tenta confirmar a conta com um endereço de e-mail ou número de telefone que já foi fornecido como um pseudónimo para um perfil de utilizador diferente. Esta exceção indica que já existe uma conta com este endereço de e-mail ou telefone num grupo de utilizadores que configurou para utilizar o endereço de e-mail ou número de telefone como um pseudónimo de início de sessão.",
        'CodeMismatchException':"Código de verificação inválido. Verifique o código e tente novamente.",
        'ForbiddenException':"Esta exceção é acionada quando o AWS WAF não autoriza o pedido com base num ACL Web associado ao seu grupo de utilizadores.",
        'InvalidLambdaResponseException':"Esta exceção é acionada quando a Amazon Cognito encontra uma resposta AWS Lambda inválida.",
        'InvalidParameterException':"Esta exceção é acionada quando o serviço Amazon Cognito encontra um parâmetro inválido.",
        'InvalidSmsRoleAccessPolicyException':"Esta exceção é devolvida quando a função fornecida para a configuração SMS não tem permissão para publicar utilizando o Amazon SNS.",
        'InvalidSmsRoleTrustRelationshipException':"Esta exceção é acionada quando a relação de confiança não é válida para a função fornecida para a configuração SMS. Isto pode acontecer se não confiar em cognito-idp.amazonaws.com ou se a ID externa fornecida na função não corresponder à fornecida na configuração SMS para o grupo de utilizadores.",
        'InvalidUserPoolConfigurationException':"Esta exceção é acionada quando a configuração do grupo de utilizadores não é válida.",
        'MFAMethodNotFoundException':"Esta exceção é acionada quando a Amazon Cognito não consegue encontrar um método de autenticação multifator (MFA).",
        "PasswordResetRequiredException":"Esta exceção é acionada quando é necessária uma reposição da palavra-passe.",
        "ResourceNotFoundException":"Esta exceção é acionada quando o serviço Amazon Cognito não consegue encontrar o recurso solicitado.",
        "SoftwareTokenMFANotFoundException":"Esta exceção é acionada quando a autenticação multifator (MFA) baseada no token de software de palavra-passe única (TOTP) não está ativada para o grupo de utilizadores.",
        "UnexpectedLambdaException":"Esta exceção é acionada quando a Amazon Cognito encontra uma exceção inesperada com a AWS Lambda.",
        "UserLambdaValidationException":"Esta exceção é acionada quando o serviço Amazon Cognito encontra uma exceção de validação do utilizador com o serviço AWS Lambda.",
        "LimitExceededException":"Esta exceção é acionada quando um utilizador excede o limite para um recurso AWS solicitado.",
        "TooManyFailedAttemptsException":"Esta exceção é acionada quando o utilizador tiver realizado demasiadas tentativas falhadas para uma determinada ação, como iniciar sessão.",
        "CodeDeliveryFailureException":"Esta exceção é acionada quando um código de verificação não é entregue com sucesso.",
        "InvalidEmailRoleAccessPolicyException":"Esta exceção é acionada quando a Amazon Cognito não está autorizada a utilizar a sua identidade de e-mail. Código de estado HTTP: 400.",
        "ConcurrentModificationException":"Esta exceção é acionada se estiverem a ocorrer duas ou mais modificações em simultâneo.",
        "EnableSoftwareTokenMFAException":"Esta exceção é acionada quando há uma diferença de código e o serviço não consegue configurar o token de software TOTP.",
	},
    'tur':{
		'InternalErrorException': 'Bir hata oluştu. Lütfen daha sonra tekrar deneyin.',
		'UserNotFoundException':'Kullanıcı bulunamadı.',
		'NotAuthorizedException':'Yanlış kullanıcı adı veya parola.',
		'UserNotConfirmedException':'Hesabınızla ilgili bir sorun oluştu. Yardım almak için lütfen @emailId adresi üzerinden iletişime geçin.',
		'ExpiredCodeException':'Geçici parolanın süresi geçti ve bir yönetici tarafından sıfırlanması gerekiyor.',
		'UserIsDisabledException':'Kullanıcı devre dışı bırakıldı ve yönetim birimi tarafından etkinleştirilmesi gerekiyor.',
		'PasswordPolicyException':'Parolalar en az sekiz karakterden oluşmalı ve rakam, özel karakter, büyük ve küçük harf içermelidir.',
		'ConfirmPasswordNotMatchException':'Parola ve onaylanan parola eşleşmelidir.',
		'ValidateUserNameAndPassword':'Kullanıcı adı ve parola gerekiyor.',
		'InvalidCodeException':'Geçersiz doğrulama kodu girildi, lütfen daha sonra tekrar deneyin.',
		'InvalidSessionForUserException':'Kullanıcı için geçersiz oturum, oturumun süresi doldu. Lütfen tekrar giriş yapın.',
		'ValidateUserName':'Kullanıcı adı gerekiyor.',
		'TooManyRequestsException':'Başarılı giriş deneme sayısı aşıldı, lütfen 30 dakika sonra tekrar deneyin.',
		'InvalidUsername':'Kullanıcı adı 1 ila 128 karakter uzunluğunda olmalı ve boşluk içermemelidir.',
        'MFAREQUIRED':"Kısa mesaj veya Kimlik Doğrulama Uygulaması veya E-posta seçmelisiniz",
        'InvalidPasswordException':"Parolalar en az sekiz karakterden oluşmalı ve rakam, özel karakter, büyük ve küçük harf içermelidir.",

        //'User does not have delivery config set to turn on SOFTWARE_TOKEN_MFA': 'Please click "Register App" and complete the registration before enabling Authenticator App',

        'AliasExistsException':"Kullanıcı, farklı bir kullanıcının halihazırda kullandığı bir takma isimle açılmış olan bir e-posta adresi veya telefon numarasıyla hesabı onaylamaya çalıştığında bu durum ortaya çıkar. Bu durum, kullanıcı havuzunda oturum açarken girdiğiniz takma isim, e-posta adresi veya telefon numarasına sahip başka bir hesabın zaten var olduğunu gösterir.",
        'CodeMismatchException':"Geçersiz doğrulama kodu. Lütfen kodu kontrol edin ve tekrar deneyin.",
        'ForbiddenException':"Bu durum, AWS WAF, kullanıcı havuzunuzla ilişkili bir web ACL’ye dayalı isteğinize izin vermediğinde ortaya çıkar.",
        'InvalidLambdaResponseException':"Bu durum, Amazon Cognito geçersiz bir AWS Lambda yanıtıyla karşılaştığında ortaya çıkar.",
        'InvalidParameterException':"Bu durum, Amazon Cognito hizmeti geçersiz bir parametreyle karşılaştığında ortaya çıkar.",
        'InvalidSmsRoleAccessPolicyException':"Bu durum, kısa mesaj yapılandırması için sağlanan rolün Amazon SNS kullanılarak yayınlanmasına izin verilmediğinde ortaya çıkar.",
        'InvalidSmsRoleTrustRelationshipException':"Bu durum, kısa mesaj yapılandırması için sağlanan rolde güven ilişkisi kurulamadığında ortaya çıkar. Bu durum, cognito-idp.amazonaws.com adresine güvenmediğinizde veya rolde sağlanan harici kimlik bilgisi, kullanıcı havuzu için kısa mesaj yapılandırmasında verilen kimlik bilgisiyle eşleşmediğinde ortaya çıkabilir.",
        'InvalidUserPoolConfigurationException':"Bu durum, kullanıcı havuzu yapılandırması geçerli olmadığında ortaya çıkar.",
        'MFAMethodNotFoundException':"Bu durum, Amazon Cognito herhangi bir çoklu onaylama (MFA) metodu bulamadığında ortaya çıkar.",
        "PasswordResetRequiredException":"Bu durum, parola sıfırlama gerektiğinde ortaya çıkar.",
        "ResourceNotFoundException":"Bu durum, Amazon Cognito hizmeti gerekli kaynağı bulamadığında ortaya çıkar.",
        "SoftwareTokenMFANotFoundException":"Bu durum, kullanıcı havuzu için yazılım belirteci zaman tabanlı tek seferlik parola (TOTP) çoklu onaylama (MFA) metodu etkinleştirilmediğinde ortaya çıkar.",
        "UnexpectedLambdaException":"Bu durum, Amazon Cognito, AWS Lambda üzerinde beklenmedik bir durumla karşılaştığında ortaya çıkar.",
        "UserLambdaValidationException":"Bu durum, Amazon Cognito hizmeti AWS Lambda hizmetinde bir kullanıcı doğrulama durumuyla karşılaştığında ortaya çıkar.",
        "LimitExceededException":"Bu durum, herhangi bir kullanıcı gerekli AWS kaynak limitini aştığında ortaya çıkar.",
        "TooManyFailedAttemptsException":"Bu durum, kullanıcı giriş yapmak gibi herhangi bir işlemde fazlasıyla hatalı girişimde bulunduğunda ortaya çıkar.",
        "CodeDeliveryFailureException":"Bu durum, doğrulama kodu başarıyla teslim edilemediğinde ortaya çıkar.",
        "InvalidEmailRoleAccessPolicyException":"Bu durum, Amazon Cognito e-posta kimliğinizi kullanma iznine sahip olmadığında ortaya çıkar. HTTP durum kodu: 400.",
        "ConcurrentModificationException":"Bu durum, iki veya daha fazla düzenleme işlemi aynı anda yapıldığında ortaya çıkar.",
        "EnableSoftwareTokenMFAException":"Bu durum, herhangi bir kod uyuşmazlığı olduğunda veya hizmet, yazılım belirteci TOTP çoklu onaylama (MFA) metodunu yapılandıramadığı zaman ortaya çıkar.",
    },
	'th': {
        'InternalErrorException': 'พบข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
		'UserNotFoundException':'ไม่พบผู้ใช้งานนี้',
		'NotAuthorizedException':'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง',
		'UserNotConfirmedException':'หากพบปัญหากับบัญชีของคุณ กรุณาติดต่อ @emailId เพื่อขอความช่วยเหลือ',
		'ExpiredCodeException':'รหัสผ่านชั่วคราวหมดอายุแล้วและต้องรีเซ็ตโดยผู้ดูแลระบบ',
		'UserIsDisabledException':'ผู้ใช้ถูกปิดใช้งานและต้องเปิดใช้งานโดยการดูแลระบบ',
        'PasswordPolicyException':'รหัสผ่านต้องมีอักขระ ตัวเลข อักขระพิเศษ ตัวพิมพ์ใหญ่และตัวพิมพ์เล็กอย่างน้อยแปดตัว',
		'ConfirmPasswordNotMatchException':'รหัสผ่านและยืนยันรหัสผ่านจะต้องตรงกัน',
		'ValidateUserNameAndPassword':'จำเป็นต้องใช้ชื่อผู้ใช้และรหัสผ่าน',
		'InvalidCodeException':'ระบุรหัสยืนยันไม่ถูกต้อง โปรดลองอีกครั้ง',
		'InvalidSessionForUserException':'เซสชั่นนี้หมดอายุแล้ว กรุณาเข้าสู่ระบบใหม่อีกครั้ง',
		'ValidateUserName':'ต้องใช้ชื่อผู้ใช้',
		'TooManyRequestsException':'การพยายามเข้าถึงเกินจำนวนครั้งที่กำหนด โปรดลองใหม่อีกครั้งในอีก 30 นาที',
		'InvalidUsername':'ชื่อผู้ใช้ควรมีความยาวระหว่าง 1 ถึง 128 อักขระ และห้ามเว้นวรรค',
        'InvalidPasswordException':'รหัสผ่านต้องมีอักขระ ตัวเลข อักขระพิเศษ ตัวพิมพ์ใหญ่และตัวพิมพ์เล็กอย่างน้อยแปดตัว',

        'MFAREQUIRED':"คุณต้องเลือกระหว่าง SMS หรือแอป Auth",
        'AliasExistsException':"ข้อยกเว้นนี้เกิดขึ้นเมื่อผู้ใช้พยายามยืนยันบัญชีด้วยอีเมลหรือหมายเลขโทรศัพท์ที่ถูกระบุไว้ใช้เป็นนามแฝงสำหรับผู้ใช้อื่นแล้ว ข้อยกเว้นนี้บ่งชี้ว่ามีบัญชีที่ใช้อีเมลหรือโทรศัพท์นี้อยู่แล้วในกลุ่มผู้ใช้ที่คุณได้กำหนดค่าให้ใช้อีเมลหรือหมายเลขโทรศัพท์นี้เป็นนามแฝงในการลงชื่อเข้าใช้",
        'CodeMismatchException':"รหัสยืนยันไม่ถูกต้อง โปรดตรวจสอบรหัสและลองอีกครั้ง",
        'ForbiddenException':"ข้อยกเว้นนี้เกิดขึ้นเมื่อ AWS WAF ไม่อนุญาตคำขอของคุณตาม ACL ของเว็บที่เชื่อมโยงกับกลุ่มผู้ใช้ของคุณ",
        'InvalidLambdaResponseException':"ข้อยกเว้นนี้เกิดขึ้นเมื่อ Amazon Cognito พบการตอบสนองของ AWS Lambda ที่ไม่ถูกต้อง",
        'InvalidParameterException':"ข้อยกเว้นนี้เกิดขึ้นเมื่อบริการ Amazon Cognito พบพารามิเตอร์ที่ไม่ถูกต้อง",
        'InvalidSmsRoleAccessPolicyException':"ข้อยกเว้นนี้จะถูกส่งกลับเมื่อบทบาทที่มีให้ในการกำหนดค่า SMS ไม่มีสิทธิ์เผยแพร่โดยใช้ Amazon SNS",
        'InvalidSmsRoleTrustRelationshipException':"ข้อยกเว้นนี้เกิดขึ้นเมื่อความสัมพันธ์ที่เชื่อถือได้ไม่ถูกต้องสำหรับบทบาทที่มีให้สำหรับการกำหนดค่า SMS กรณีนี้อาจเกิดขึ้นได้หากคุณไม่ยอมรับ cognito-idp.amazonaws.com หรือหาก ID ที่ระบุไว้ในบทบาทไม่ตรงกับที่ระบุไว้ในการกำหนดค่า SMS สำหรับกลุ่มผู้ใช้",
        'InvalidUserPoolConfigurationException':"ข้อยกเว้นนี้เกิดขึ้นเมื่อมีการกำหนดค่ากลุ่มผู้ใช้ไม่ถูกต้อง",
        'MFAMethodNotFoundException':"ข้อยกเว้นนี้เกิดขึ้นเมื่อ Amazon Cognito ไม่พบวิธีการยืนยันตัวตนโดยใช้หลายปัจจัย (MFA)",
        "PasswordResetRequiredException":"ข้อยกเว้นนี้เกิดขึ้นเมื่อจำเป็นต้องรีเซ็ตรหัสผ่าน",
        "ResourceNotFoundException":"ข้อยกเว้นนี้เกิดขึ้นเมื่อ Amazon Cognito Service ไม่พบแหล่งข้อมูลที่ร้องขอ",
        "SoftwareTokenMFANotFoundException":"ข้อยกเว้นนี้เกิดขึ้นเมื่อการยืนยันตัวตนโดยใช้หลายปัจจัย (MFA) ซอฟต์แวร์โทเค็นแบบใส่รหัสผ่านครั้งเดียว (TOTP) ไม่ได้เปิดใช้งานสำหรับกลุ่มผู้ใช้",
        "UnexpectedLambdaException":"ข้อยกเว้นนี้เกิดขึ้นเมื่อ Amazon Cognito พบข้อผิดพลาดที่ไม่คาดคิดกับ AWS Lambda",
        "UserLambdaValidationException":"ข้อยกเว้นนี้เกิดขึ้นเมื่อ Amazon Cognito Service พบข้อผิดพลาดในการตรวจสอบความถูกต้องของผู้ใช้ AWS Lambda Service",
        "LimitExceededException":"ข้อยกเว้นนี้เกิดขึ้นเมื่อผู้ใช้ร้องขอการเข้าใช้แหล่งข้อมูล AWS เกินจำนวนครั้งที่กำหนด",
        "TooManyFailedAttemptsException":"ข้อยกเว้นนี้เกิดขึ้นเมื่อมีความล้มเหลวในการดำเนินการเกินจำนวนครั้งที่กำหนด เช่น การลงชื่อเข้าใช้",
        "CodeDeliveryFailureException":"ข้อยกเว้นนี้เกิดขึ้นเมื่อระบบไม่สามารถส่งรหัสการตรวจสอบความถูกต้องได้สำเร็จ",
        "InvalidEmailRoleAccessPolicyException":"ข้อยกเว้นนี้เกิดขึ้นเมื่อ Amazon Cognito ไม่ได้รับอนุญาตให้เข้าถึงอีเมลของคุณ รหัสสถานะ HTTP: 400",
        "ConcurrentModificationException":"ข้อยกเว้นนี้เกิดขึ้นหากมีการแก้ไขอย่างน้อย 2 รายการพร้อมกัน",
        "EnableSoftwareTokenMFAException":"ข้อยกเว้นนี้เกิดขึ้นเมื่อมีรหัสไม่ตรงกันและระบบไม่สามารถรับรองการยืนยันตัวตนโดยใช้หลายปัจจัย (MFA) แบบ TOTP ได้",
    },
	'vi': {
		'InternalErrorException': 'Đã xảy ra lỗi nội bộ, vui lòng thử lại sau.',
		'UserNotFoundException':'Người dùng không tồn tại.',
		'NotAuthorizedException':'Tên đăng nhập hoặc mật khẩu không chính xác',
		'UserNotConfirmedException':'Có vấn đề với tài khoản của bạn. Vui lòng liên hệ @emailId để được hỗ trợ.',
		'ExpiredCodeException':'Mật khẩu tạm thời đã hết hạn và phải được quản trị viên đặt lại.',
		'UserIsDisabledException':'Người dùng bị vô hiệu hóa và phải được quản lý cho phép.',
        'PasswordPolicyException':'Mật khẩu phải chứa ít nhất tám ký tự, số, ký tự đặc biệt, chữ hoa và chữ thường.',
		'ConfirmPasswordNotMatchException':'Mật khẩu và mật khẩu xác nhận phải khớp.',
		'ValidateUserNameAndPassword':'Tên người dùng và mật khẩu là bắt buộc.',
		'InvalidCodeException':'Mã xác minh được cung cấp không hợp lệ, vui lòng thử lại.',
		'InvalidSessionForUserException':'Phiên không hợp lệ cho người dùng, phiên đã hết hạn. Vui lòng đăng nhập lại.',
		'ValidateUserName':'Tên người dùng là bắt buộc.',
		'TooManyRequestsException':'Số lần thử truy cập vượt quá quy định, vui lòng thử lại sau 30 phút.',
		'InvalidUsername':'Tên người dùng phải dài từ 1 đến 128 ký tự và không thể chứa bất kỳ khoảng trắng nào.',
        'InvalidPasswordException':'Mật khẩu phải chứa ít nhất tám ký tự, số, ký tự đặc biệt, chữ hoa và chữ thường.',

        'MFAREQUIRED':"Bạn phải chọn SMS hoặc Ứng dụng Auth",
        'AliasExistsException':"Ngoại lệ này được tạo khi người dùng tìm cách xác nhận tài khoản có địa chỉ email hoặc số điện thoại đã được dùng làm biệt danh cho một hồ sơ người dùng khác. Ngoại lệ này cho biết một tài khoản có địa chỉ email hoặc số điện thoại này đã tồn tại trong nhóm người dùng mà bạn đã đặt cấu hình để sử dụng địa chỉ email hoặc số điện thoại làm biệt danh đăng nhập.",
        'CodeMismatchException':"Mã xác minh không hợp lệ. Vui lòng kiểm tra mã và thử lại.",
        'ForbiddenException':"Ngoại lệ này được tạo khi AWS WAF không cho phép yêu cầu dựa trên ACL web liên kết với nhóm người dùng của bạn.",
        'InvalidLambdaResponseException':"Ngoại lệ này được tạo khi Amazon Cognito nhận được phản hồi AWS Lambda không hợp lệ.",
        'InvalidParameterException':"Ngoại lệ này được tạo khi dịch vụ Amazon Cognito nhận được thông số không hợp lệ.",
        'InvalidSmsRoleAccessPolicyException':"Ngoại lệ này được trả về khi vai trò được cung cấp cho cấu hình SMS không có quyền phát hành bằng Amazon SNS.",
        'InvalidSmsRoleTrustRelationshipException':"Ngoại lệ này được tạo khi mối quan hệ tin cậy không hợp lệ đối với vai trò được cung cấp cho cấu hình SMS. Điều này có thể xảy ra nếu bạn không tin cậy cognito-idp.amazonaws.com hoặc ID bên ngoài được cung cấp trong vai trò này không khớp với ID được cung cấp trong cấu hình SMS của nhóm người dùng.",
        'InvalidUserPoolConfigurationException':"Ngoại lệ này được tạo khi cấu hình nhóm người dùng không hợp lệ.",
        'MFAMethodNotFoundException':"Ngoại lệ này được tạo khi Amazon Cognito không tìm thấy phương thức xác thực đa yếu tố (MFA).",
        "PasswordResetRequiredException":"Ngoại lệ này được tạo khi cần đặt lại mật khẩu.",
        "ResourceNotFoundException":"Ngoại lệ này được tạo khi dịch vụ Amazon Cognito không tìm thấy tài nguyên được yêu cầu.",
        "SoftwareTokenMFANotFoundException":"Ngoại lệ này được tạo khi bạn không kích hoạt phương thức xác thực đa yếu tố (MFA) mật khẩu một lần dựa trên thời gian (TOTP) của mã thông báo phần mềm cho nhóm người dùng.",
        "UnexpectedLambdaException":"Ngoại lệ này được tạo khi Amazon Cognito nhận được ngoại lệ không mong muốn với AWS Lambda.",
        "UserLambdaValidationException":"Ngoại lệ này được tạo khi dịch vụ Amazon Cognito nhận được ngoại lệ xác thực người dùng với dịch vụ AWS Lambda.",
        "LimitExceededException":"Ngoại lệ này được tạo khi người dùng vượt quá giới hạn đối với một tài nguyên AWS được yêu cầu.",
        "TooManyFailedAttemptsException":"Ngoại lệ này được tạo khi người dùng đã thử một hành động nhất định không thành công quá nhiều lần, chẳng hạn như đăng nhập.",
        "CodeDeliveryFailureException":"Ngoại lệ này được tạo khi mã xác minh không được gửi thành công.",
        "InvalidEmailRoleAccessPolicyException":"Ngoại lệ này được tạo khi Amazon Cognito không được phép sử dụng danh tính email của bạn. Mã trạng thái HTTP: 400.",
        "ConcurrentModificationException":"Ngoại lệ này được tạo khi hai hoặc nhiều sửa đổi xảy ra đồng thời.",
        "EnableSoftwareTokenMFAException":"Ngoại lệ này được tạo khi mã không khớp và dịch vụ không thiết lập được phương thức xác thực đa yếu tố (MFA) TOTP của mã thông báo phần mềm.",
    },
	'ko':{
		'InternalErrorException':'내부 오류가 발생했습니다. 나중에 다시 시도하십시오.',
		'UserNotFoundException':'사용자가 존재하지 않습니다.',
		'NotAuthorizedException':'사용자 이름 또는 비밀번호가 잘못되었습니다.',
		'UserNotConfirmedException':'계정에 문제가 있습니다. 도움이 필요하면 @emailId 로 문의하십시오.',
		'ExpiredCodeException':'임시 비밀번호가 만료되었습니다. 관리자가 재설정해야 합니다.',
		'UserIsDisabledException':'사용자가 비활성화되어 있으며 관리자가 활성화해야 합니다.',
        'PasswordPolicyException':'비밀번호는 최소 8자, 숫자, 특수문자, 대문자, 소문자를 포함해야 합니다.',
		'ConfirmPasswordNotMatchException':'비밀번호와 확인 비밀번호가 일치해야 합니다.',
		'ValidateUserNameAndPassword':'사용자 이름과 비밀번호가 필요합니다',
		'InvalidCodeException':'잘못된 인증 코드를 제공했습니다. 다시 시도해 주세요.',
		'InvalidSessionForUserException':'사용자의 세션이 잘못되었습니다. 세션이 만료되었습니다. 다시 로그인하세요.',
		'Invalid session for the user.':'세션이 만료되었습니다. 로그인 프로세스를 다시 시작하십시오.',
		'ValidateUserName':'사용자 이름이 필요합니다.',
		'TooManyRequestsException':'액세스 시도 횟수를 초과했습니다. 30분후에 다시 시도하십시오.',
		'InvalidUsername':'사용자 이름은 길이가 1~128자여야 하며 공백을 포함할 수 없습니다.',
        'InvalidPasswordException':'비밀번호는 최소 8자, 숫자, 특수문자, 대문자, 소문자를 포함해야 합니다.',

        'MFAREQUIRED':"SMS 또는 인증자 앱을 선택해야 합니다.",
        'AliasExistsException':"이 예외는 사용자가 다른 사용자 프로필에 대한 별칭으로 이미 제공된 이메일 주소 또는 전화 번호를 이용하여 계정을 확인하려고 할 경우에 발생합니다. 이 예외는 이메일 주소 또는 전화 번호를 로그인 별칭으로 사용하도록 구성한 사용자 풀에 이 이메일 주소 또는 전화 번호를 사용하는 계정이 이미 존재함을 나타냅니다.",
        'CodeMismatchException':"잘못된 인증 코드입니다. 코드를 확인하고 다시 시도하십시오.",
        'ForbiddenException':"이 예외는 AWS WAF가 사용자 풀과 연결된 웹 ACL을 기반으로 하는 요청을 허용하지 않을 경우에 발생합니다.",
        'InvalidLambdaResponseException':"이 예외는 Amazon Cognito가 잘못된 AWS Lambda 응답을 발견할 경우에 발생합니다.",
        'InvalidParameterException':"이 예외는 Amazon Cognito 서비스가 잘못된 매개 변수를 발견할 경우에 발생합니다.",
        'InvalidSmsRoleAccessPolicyException':"이 예외는 SMS 구성에 제공된 역할에 Amazon SNS를 사용하여 게시할 수 있는 권한이 없을 경우에 반환됩니다.",
        'InvalidSmsRoleTrustRelationshipException':"이 예외는 신뢰 관계가 SMS 구성에 대해 제공된 역할에 유효하지 않을 경우에 발생합니다. 이 문제는 cognito-idp.amazonaws.com을 신뢰하지 않거나 역할에 제공된 외부 ID가 사용자 풀에 대한 SMS 구성에 제공된 ID와 일치하지 않는 경우에 발생할 수 있습니다.",
        'InvalidUserPoolConfigurationException':"이 예외는 사용자 풀 구성이 유효하지 않을 경우에 발생합니다.",
        'MFAMethodNotFoundException':"이 예외는 Amazon Cognito에서 다단계 인증(MFA) 방법을 찾을 수 없을 경우에 발생합니다.",
        "PasswordResetRequiredException":"이 예외는 암호 재설정이 필요한 경우에 발생합니다.",
        "ResourceNotFoundException":"이 예외는 Amazon Cognito 서비스에서 요청된 리소스를 찾을 수 없을 경우에 발생합니다.",
        "SoftwareTokenMFANotFoundException":"이 예외는 사용자 풀에 대해 소프트웨어 토큰 시간 기반 일회용 암호(TOTP) 다단계 인증(MFA)이 활성화되지 않은 경우에 발생합니다.",
        "UnexpectedLambdaException":"이 예외는 Amazon Cognito가 AWS Lambda에서 예상치 못한 예외를 발견할 경우에 발생합니다.",
        "UserLambdaValidationException":"이 예외는 Amazon Cognito 서비스가 AWS Lambda 서비스에서 사용자 검증 예외를 발견할 경우에 발생합니다.",
        "LimitExceededException":"이 예외는 사용자가 요청된 AWS 리소스에 대한 제한을 초과할 경우에 발생합니다.",
        "TooManyFailedAttemptsException":"이 예외는 사용자가 로그인과 같은 지정된 작업에 대해 실패 시도가 너무 많은 경우에 발생합니다.",
        "CodeDeliveryFailureException":"이 예외는 확인 코드가 성공적으로 전달되지 않은 경우에 발생합니다.",
        "InvalidEmailRoleAccessPolicyException":"이 예외는 Amazon Cognito가 이메일 ID를 사용할 수 없는 경우에 적용됩니다. HTTP 상태 코드: 400.",
        "ConcurrentModificationException":"이 예외는 두 개 이상의 수정이 동시에 발생하는 경우에 발생합니다.",
        "EnableSoftwareTokenMFAException":"이 예외는 코드 불일치가 있고 서비스가 소프트웨어 토큰 TOTP 다단계 인증(MFA)을 구성하지 못하는 경우에 발생합니다.",
    },
	'zh': {
        'InternalErrorException': '有内部错误,请稍后尝试。',
		'UserNotFoundException':'用户不存在',
		'NotAuthorizedException':'用户名或密码不正确',
		'UserNotConfirmedException':'您的帐户有问题。请与 @emailId 联系以获得帮助',
		'ExpiredCodeException':'临时密码已过期，必须由管理员重置。',
		'UserIsDisabledException':'用户已禁用,必须通过管理来启用。',
        'PasswordPolicyException':'密码必须至少包含八个字符、数字、特殊字符、大写字母和小写字母。',
		'ConfirmPasswordNotMatchException':'密码和确认密码必须匹配',
		'ValidateUserNameAndPassword':'需要用户名和密码',
		'InvalidCodeException':'提供的验证码无效，请重试。',
		'InvalidSessionForUserException':'用户的会话无效,会话已过期。请再次登录。',
		'ValidateUserName':'需要用户名。',
		'TooManyRequestsException':'已超过访问尝试次数，请在30分钟后重新尝试。',
		'InvalidUsername':'用户名的长度应在1至128个字符之间，不能包含任何白色空间。',
        'InvalidPasswordException':'密码必须至少包含八个字符、数字、特殊字符、大写字母和小写字母。',

        'MFAREQUIRED':"您必须选择 SMS 或身份验证应用程序",
        'AliasExistsException':"当用户尝试使用已作为其他用户配置文件的别名提供的电子邮件地址或电话号码确认帐户时，会引发此异常。此例外表明，您配置为使用电子邮件地址或电话号码作为登录别名的用户池中，已存在具有此电子邮件地址或电话的帐户。",
        'CodeMismatchException':"验证码无效。请检查代码并重试。",
        'ForbiddenException':"当 AWS WAF 不允许基于与您的用户池关联的 Web ACL 提出的请求时，会引发此异常。",
        'InvalidLambdaResponseException':"当 Amazon Cognito 遇到无效的 AWS Lambda 响应时，会引发此异常。",
        'InvalidParameterException':"当 Amazon Cognito 服务遇到无效参数时，会引发此异常。",
        'InvalidSmsRoleAccessPolicyException':"当为 SMS 配置提供的角色无权使用 Amazon SNS 发布时，将返回此异常。",
        'InvalidSmsRoleTrustRelationshipException':"当信任关系对提供用于 SMS 配置的角色无效时，会引发此异常。如果您不信任 cognito-idp.amazonaws.com，或角色中提供的外部 ID 与用户池的 SMS 配置中提供的 ID 不匹配，则会引发这种情况。",
        'InvalidUserPoolConfigurationException':"当用户池配置无效时，会引发此异常。",
        'MFAMethodNotFoundException':"当 Amazon Cognito 找不到多重身份验证 (MFA) 方法时，会引发此异常。",
        "PasswordResetRequiredException":"需要重置密码时，会引发此异常。",
        "ResourceNotFoundException":"当 Amazon Cognito 服务无法找到请求的资源时，会引发此异常。",
        "SoftwareTokenMFANotFoundException":"当没有为用户池激活软件令牌基于时间的一次性密码算法 (TOTP) 多重身份验证 (MFA) 时，会引发此异常。",
        "UnexpectedLambdaException":"当 Amazon Cognito 遇到 AWS Lambda 的意外异常时，会引发此异常。",
        "UserLambdaValidationException":"当 Amazon Cognito 服务遇到 AWS Lambda 服务的用户验证异常时，会引发此异常。",
        "LimitExceededException":"当用户超过所请求 AWS 资源的限制时，会引发此异常。",
        "TooManyFailedAttemptsException":"当用户对登录等给定操作尝试失败的次数过多时，会引发此异常。",
        "CodeDeliveryFailureException":"当无法成功交付验证码时，会引发此异常。",
        "InvalidEmailRoleAccessPolicyException":"当不允许 Amazon Cognito 使用您的电子邮件身份时，会引发此异常。HTTP 状态码：400。",
        "ConcurrentModificationException":"如果同时进行两个或多个修改，会引发此异常。",
        "EnableSoftwareTokenMFAException":"当验证码不匹配且服务无法配置软件令牌 TOTP 多重身份验证 (MFA) 时，会引发此异常。",
    },
	'ru': {
		'InternalErrorException': 'Возникла ошибка, повторите попытку позже.',
		'UserNotFoundException':'Профиль пользователя не найден.',
		'NotAuthorizedException':'Неверное имя пользователя или пароль.',
		'UserNotConfirmedException':'Возникла проблема с вашей учетной записью. Пожалуйста, обратитесь за помощью на электронную почту @emailId.',
		'ExpiredCodeException':'Временный пароль истек и должен быть сброшен администратором.',
		'UserIsDisabledException':'Пользователь отключен и должен быть активирован администратором.',
        'PasswordPolicyException':'Пароли должны содержать не менее восьми символов, цифр, специальных символов, заглавных и строчных букв.',
		'ConfirmPasswordNotMatchException':'Пароль и подтверждение пароля не совпадают.',
		'ValidateUserNameAndPassword':'Требуется имя пользователя и пароль.',
		'InvalidCodeException':'Предоставлен неверный код подтверждения, попробуйте еще раз.',
		'InvalidSessionForUserException':'Сессия истекла. Пожалуйста, войдите снова.',
		'ValidateUserName':'Требуется имя пользователя.',
		'TooManyRequestsException':'Количество попыток входа превышено, пожалуйста, повторите попытку через 30 минут.',
		'InvalidUsername':'Имя пользователя должно быть длиной от 1 до 128 символов и не должно содержать пробелов.',
        'InvalidPasswordException':'Пароли должны содержать не менее восьми символов, цифр, специальных символов, заглавных и строчных букв.',

        'MFAREQUIRED':"You must select either SMS, Auth APP, or Email",
        'AliasExistsException':"This exception is thrown when ",
        'CodeMismatchException':"Недействительный код подтверждения. Пожалуйста, проверьте код и попробуйте снова.",
        'ForbiddenException':"This exception is thrown when AWS ",
        'InvalidLambdaResponseException':"This exception is thrown when Amazon Cognito ",
        'InvalidParameterException':"This exception is thrown when the Amazon Cognito service ",
        'InvalidSmsRoleAccessPolicyException':"This exception is returned when the role ",
        'InvalidSmsRoleTrustRelationshipException':"This exception is thrown when the trust ",
        'InvalidUserPoolConfigurationException':"This exception is thrown when the user pool configuration ",
        'MFAMethodNotFoundException':"This exception is thrown when Amazon Cognito can't find a multi-factor ",
        "PasswordResetRequiredException":"This exception is thrown when a password reset is required.",
        "ResourceNotFoundException":"This exception is thrown when the Amazon Cognito service can't ",
        "SoftwareTokenMFANotFoundException":"This exception is thrown when the software token time-based one-time ",
        "UnexpectedLambdaException":"This exception is thrown when Amazon Cognito encounters an unexpected ",
        "UserLambdaValidationException":"This exception is thrown when the Amazon Cognito service encounters ",
        "LimitExceededException":"This exception is thrown when a user exceeds the limit for a requested AWS resource.",
        "TooManyFailedAttemptsException":"This exception is thrown when the user has made too many failed ",
        "CodeDeliveryFailureException":"This exception is thrown when a verification code fails to deliver successfully.",
        "InvalidEmailRoleAccessPolicyException":"This exception is thrown when Amazon Cognito isn't ",
        "ConcurrentModificationException":"This exception is thrown if two or more modifications ",
        "EnableSoftwareTokenMFAException":"This exception is thrown when there is a code mismatch",
   },
   'it':{
		'InternalErrorException': "C'è un errore interno, riprova più tardi.",
		'UserNotFoundException':"L'utente non esiste.",
		'NotAuthorizedException':'Nome utente o password errati.',
		'UserNotConfirmedException':"C'è un problema con il tuo account. Si prega di contattare @emailId per assistenza.",
		'ExpiredCodeException':'La password temporanea è scaduta e deve essere reimpostata da un amministratore.',
		'UserIsDisabledException':"L'utente è disabilitato e deve essere abilitato dall'amministratore.",
        'PasswordPolicyException':'Le password devono contenere almeno otto caratteri, numeri, caratteri speciali, lettere maiuscole e minuscole.',
		'ConfirmPasswordNotMatchException':'La password e la conferma della password devono corrispondere.',
		'ValidateUserNameAndPassword':'Nome utente e password richiesti.',
		'InvalidCodeException':'Codice di verifica fornito non valido, riprova.',
		'InvalidSessionForUserException':"Sessione non valida per l'utente, la sessione è scaduta. Effettuare nuovamente l'accesso.",
		'Invalid session for the user.':'La sessione è scaduta. Si prega di riavviare il processo di accesso.',
		'ValidateUserName':'Il nome utente è richiesto.',
		'TooManyRequestsException':'Numero di tentativi di accesso superato, riprova dopo 30 minuti.',
		'InvalidUsername':"Il nome utente deve avere una lunghezza da 1 a 128 caratteri e non puo' contenere spazi.",
        'InvalidPasswordException':'Le password devono contenere almeno otto caratteri, numeri, caratteri speciali, lettere maiuscole e minuscole.',

        'MFAREQUIRED':"Devi selezionare l’autenticazione tramite SMS o app",
        'AliasExistsException':"Questa eccezione viene generata quando un utente tenta di confermare l’account con un indirizzo e-mail o un numero di telefono già fornito come alias per un profilo utente diverso. Questa eccezione indica che un account con questo indirizzo e-mail o telefono esiste già in un pool di utenti che hai configurato per utilizzare l’indirizzo e-mail o il numero di telefono come alias di accesso.",
        'CodeMismatchException':"Codice di verifica non valido. Controlla il codice e riprova.",
        'ForbiddenException':"Questa eccezione viene generata quando AWS WAF non consente la richiesta in base a un ACL web associato al pool di utenti.",
        'InvalidLambdaResponseException':"Questa eccezione viene generata quando Amazon Cognito incontra una risposta AWS Lambda non valida.",
        'InvalidParameterException':"Questa eccezione viene generata quando il servizio Amazon Cognito incontra un parametro non valido.",
        'InvalidSmsRoleAccessPolicyException':"Questa eccezione viene proposta quando il ruolo fornito per la configurazione SMS non dispone dell'autorizzazione per la pubblicazione utilizzando Amazon SNS.",
        'InvalidSmsRoleTrustRelationshipException':"Questa eccezione viene generata quando la relazione di attendibilità non è valida per il ruolo fornito per la configurazione SMS. Ciò può accadere se cognito-idp.amazonaws.com è ritenuto non affidabile o se l’ID esterno fornito nel ruolo non corrisponde a quello fornito nella configurazione SMS per il pool di utenti.",
        'InvalidUserPoolConfigurationException':"Questa eccezione viene generata quando la configurazione del pool di utenti non è valida.",
        'MFAMethodNotFoundException':"Questa eccezione viene generata quando Amazon Cognito non riesce a trovare un metodo di autenticazione a più fattori (MFA).",
        "PasswordResetRequiredException":"Questa eccezione viene generata quando è necessario reimpostare la password.",
        "ResourceNotFoundException":"Questa eccezione viene generata quando il servizio Amazon Cognito non riesce a trovare la risorsa richiesta.",
        "SoftwareTokenMFANotFoundException":"Questa eccezione viene generata quando l’autenticazione a più fattori (MFA) con password unica basata sul tempo (TOTP) del token software non è attivata per il pool di utenti.",
        "UnexpectedLambdaException":"Questa eccezione viene generata quando Amazon Cognito incontra un’eccezione imprevista con AWS Lambda.",
        "UserLambdaValidationException":"Questa eccezione viene generata quando il servizio Amazon Cognito incontra un’eccezione di convalida dell’utente con il servizio AWS Lambda.",
        "LimitExceededException":"Questa eccezione viene generata quando un utente supera il limite per una risorsa AWS richiesta.",
        "TooManyFailedAttemptsException":"Questa eccezione viene generata quando l’utente ha effettuato troppi tentativi non riusciti per una determinata azione, come l’accesso.",
        "CodeDeliveryFailureException":"Questa eccezione viene generata quando un codice di verifica non viene consegnato correttamente.",
        "InvalidEmailRoleAccessPolicyException":"Questa eccezione viene generata quando Amazon Cognito non è autorizzato a utilizzare la tua identità e-mail. Codice di stato HTTP: 400.",
        "ConcurrentModificationException":"Questa eccezione viene generata se due o più modifiche vengono apportate contemporaneamente.",
        "EnableSoftwareTokenMFAException":"Questa eccezione viene generata in caso di mancata corrispondenza del codice e se il servizio non riesce a configurare l’autenticazione a più fattori (MFA) TOTP del token del software.",
    },
	'hu':{ 
		'InternalErrorException': 'Belső hiba történt, kérjük, próbálja meg később újra.',
		'UserNotFoundException':'A felhasználó nem létezik.',
		'NotAuthorizedException':'Helytelen felhasználónév vagy jelszó',
		'UserNotConfirmedException':'Probléma merült fel a fiókjával kapcsolatban. Kérjük, forduljon segítségért a @emailId címre.',
		'ExpiredCodeException':'Az ideiglenes jelszó lejárt, és a rendszergazdának vissza kell állítania.',
		'UserIsDisabledException':'A felhasználó le van tiltva, és az adminisztrátornak kell engedélyeznie.',
        'PasswordPolicyException':'A jelszavaknak legalább nyolc karaktert, számokat, speciális karaktereket, nagy- és kisbetűket kell tartalmazniuk.',
		'ConfirmPasswordNotMatchException':'A jelszónak és a jelszó megerősítésének meg kell egyeznie.',
		'ValidateUserNameAndPassword':'Felhasználónév és jelszó szükséges.',
		'InvalidCodeException':'Érvénytelen ellenőrző kód, kérjük, próbálja újra.',
		'InvalidSessionForUserException':'Érvénytelen munkamenet a felhasználóhoz, a munkamenet lejárt. Kérjük, jelentkezzen be újra.',
		'Invalid session for the user.':'A munkamenet lejárt. Kérjük, indítsa újra a bejelentkezési folyamatot.',
		'ValidateUserName':'Felhasználói név szükséges.',
		'TooManyRequestsException':'A hozzáférési kísérletek száma túllépésre került, kérjük, próbálkozzon újra 30 perc múlva.',
		'InvalidUsername':"A felhasználónévnek 1 és 128 karakter közötti hosszúságúnak kell lennie, és nem tartalmazhat szóközöket.",
        'InvalidPasswordException':'A jelszavaknak legalább nyolc karaktert, számokat, speciális karaktereket, nagy- és kisbetűket kell tartalmazniuk.',

        'MFAREQUIRED':"Választania kell az SMS vagy a hitelesítő alkalmazás közül",
        'AliasExistsException':"Ez a kivétel akkor jelenik meg, ha a felhasználó olyan e-mail címmel vagy telefonszámmal próbálja megerősíteni a fiókot, amelyet már egy másik felhasználói profilhoz alias névként megadott. Ez a kivétel azt jelzi, hogy egy fiók ezzel az e-mail címmel vagy telefonnal már létezik egy felhasználói készletben, amelyet úgy konfigurált, hogy e-mail címet vagy telefonszámot használjon bejelentkezési aliasként.",
        'CodeMismatchException':"Érvénytelen ellenőrző kód. Kérjük, ellenőrizze a kódot és próbálja újra.",
        'ForbiddenException':"Ez a kivétel akkor jelenik meg, ha az AWS WAF nem engedélyezi a kérelmét a felhasználói készletéhez társított webes ACL alapján.",
        'InvalidLambdaResponseException':"Ez a kivétel akkor jelenik meg, ha az Amazon Cognito érvénytelen AWS Lambda választ észlel.",
        'InvalidParameterException':"Ez a kivétel akkor jelenik meg, ha az Amazon Cognito szolgáltatás érvénytelen paramétert észlel.",
        'InvalidSmsRoleAccessPolicyException':"Ez a kivétel akkor jelenik meg, ha az SMS-konfigurációhoz megadott szerepkörnek nincs engedélye az Amazon SNS használatával történő közzétételhez.",
        'InvalidSmsRoleTrustRelationshipException':"Ez a kivétel akkor jelenik meg, ha a megbízhatósági kapcsolat nem érvényes az SMS-konfigurációhoz megadott szerepkörre. Ez akkor fordulhat elő, ha nem bízik meg a cognito-idp.amazonaws.com weboldalban, vagy ha a szerepkörben megadott külső azonosító nem egyezik meg a felhasználói készlet SMS-konfigurációjában megadottal.",
        'InvalidUserPoolConfigurationException':"Ez a kivétel akkor jelenik meg, ha a felhasználói készlet konfigurációja nem érvényes.",
        'MFAMethodNotFoundException':"Ez a kivétel akkor fordul elő, ha az Amazon Cognito nem talál többlépcsős hitelesítési (MFA) módszert.",
        "PasswordResetRequiredException":"Ez a kivétel akkor jelenik meg, ha jelszó-visszaállításra van szükség.",
        "ResourceNotFoundException":"Ez a kivétel akkor jelenik meg, ha az Amazon Cognito szolgáltatás nem találja a kért erőforrást.",
        "SoftwareTokenMFANotFoundException":"Ez a kivétel akkor jelenik meg, ha a szoftver token időalapú egyszeri jelszavának (TOTP) többlépcsős hitelesítése (MFA) nincs aktiválva a felhasználói készlethez.",
        "UnexpectedLambdaException":"Ez a kivétel akkor fordul elő, ha az Amazon Cognito váratlan kivételt talál az AWS Lambdával.",
        "UserLambdaValidationException":"Ez a kivétel akkor fordul elő, ha az Amazon Cognito szolgáltatás felhasználói érvényesítési kivételt talál az AWS Lambda szolgáltatással.",
        "LimitExceededException":"Ez a kivétel akkor fordul elő, ha a felhasználó túllépi a kért AWS erőforrás határértékét.",
        "TooManyFailedAttemptsException":"Ez a kivétel akkor jelenik meg, ha a felhasználó túl sok sikertelen kísérletet tett egy adott műveletre, például bejelentkezésre.",
        "CodeDeliveryFailureException":"Ez a kivétel akkor fordul elő, ha az ellenőrző kód nem kézbesíthető sikeresen.",
        "InvalidEmailRoleAccessPolicyException":"Ez a kivétel akkor jelenik meg, ha az Amazon Cognito nem használhatja az Ön e-mail azonosítóját. HTTP állapotkód: 400.",
        "ConcurrentModificationException":"Ez a kivétel akkor fordul elő, ha két vagy több módosítás egyidejűleg történik.",
        "EnableSoftwareTokenMFAException":"Ez a kivétel akkor jelenik meg, ha egy kód nem egyezik, és a szolgáltatás nem tudja konfigurálni a szoftver token TOTP többtényezős hitelesítését (MFA).",
    },
	'pl': {
        'InternalErrorException': 'Wystąpił wewnętrzny błąd, spróbuj ponownie później.',
		'UserNotFoundException':'Użytkownik nie istnieje.',
		'NotAuthorizedException':'Nieprawidłowa nazwa użytkownika lub hasło.',
		'UserNotConfirmedException':'Wystąpił problem z Twoim kontem. Prosimy o kontakt z @emailId w celu uzyskania pomocy.',
		'ExpiredCodeException':'Hasło tymczasowe wygasło i musi zostać zresetowane przez administratora.',
		'UserIsDisabledException':'Użytkownik jest nieaktywny i musi zostać odblokowany przez administratora.',
        'PasswordPolicyException':'Hasła muszą zawierać co najmniej osiem znaków, cyfry, znaki specjalne, wielką i małą literę.',
		'ConfirmPasswordNotMatchException':'Hasło i potwierdzenie hasła muszą się być takie same.',
		'ValidateUserNameAndPassword':'Wymagana nazwa użytkownika i hasło.',
		'InvalidCodeException':'Podano nieprawidłowy kod weryfikacyjny, spróbuj ponownie.',
		'InvalidSessionForUserException':'Nieprawidłowa sesja dla użytkownika, sesja wygasła. Zaloguj się ponownie.',
		'ValidateUserName':'Nazwa użytkownika jest wymagana.',
		'TooManyRequestsException':'Ilość prób logowania została przekroczona, spróbuj ponownie za 30 minut.',
		'InvalidUsername':"Nazwa użytkownika powinna mieć długość od 1 do 128 znaków i nie może zawierać białych spacji.",
        'InvalidPasswordException':'Hasła muszą zawierać co najmniej osiem znaków, cyfry, znaki specjalne, wielką i małą literę.',

        'MFAREQUIRED':"Musisz wybrać opcję SMS lub Auth APP",
        'AliasExistsException':"Ten wyjątek jest wyświetlany, gdy użytkownik próbuje potwierdzić konto za pomocą adresu e-mail lub numeru telefonu, który został już podany jako alias dla innego profilu użytkownika. Ten wyjątek wskazuje, że konto z tym adresem e-mail lub telefonem już istnieje w puli użytkowników, którą skonfigurowano do używania adresu e-mail lub numeru telefonu jako aliasu logowania.",
        'CodeMismatchException':"Nieprawidłowy kod weryfikacyjny. Sprawdź kod i spróbuj ponownie.",
        'ForbiddenException':"Ten wyjątek jest wyświetlany, gdy AWS WAF nie zezwala na żądanie na podstawie sieciowego ACL powiązanego z pulą użytkowników.",
        'InvalidLambdaResponseException':"Ten wyjątek jest wyświetlany, gdy Amazon Cognito napotka nieprawidłową odpowiedź AWS Lambda.",
        'InvalidParameterException':"Ten wyjątek jest wyświetlany, gdy usługa Amazon Cognito napotka nieprawidłowy parametr.",
        'InvalidSmsRoleAccessPolicyException':"Ten wyjątek jest wyświetlany, gdy rola podana dla konfiguracji SMS nie ma uprawnień do publikowania przy użyciu Amazon SNS.",
        'InvalidSmsRoleTrustRelationshipException':"Ten wyjątek jest wyświetlany, gdy relacja zaufania nie jest prawidłowa dla roli podanej dla konfiguracji SMS. Może się to zdarzyć, jeśli nie ufasz witrynie cognito-idp.amazonaws.com lub zewnętrzny identyfikator podany w roli nie jest zgodny z konfiguracją SMS dla puli użytkowników.",
        'InvalidUserPoolConfigurationException':"Ten wyjątek jest wyświetlany, gdy konfiguracja puli użytkowników jest nieprawidłowa.",
        'MFAMethodNotFoundException':"Ten wyjątek jest wyświetlany, gdy Amazon Cognito nie może znaleźć metody uwierzytelniania wieloskładnikowego (MFA).",
        "PasswordResetRequiredException":"Ten wyjątek jest wyświetlany, gdy wymagane jest zresetowanie hasła.",
        "ResourceNotFoundException":"Ten wyjątek jest wyświetlany, gdy usługa Amazon Cognito nie może znaleźć żądanego zasobu.",
        "SoftwareTokenMFANotFoundException":"Ten wyjątek jest wyświetlany, gdy dla puli użytkowników nie jest aktywowana metoda uwierzytelniania wieloskładnikowego (MFA) z tokenem programowym z hasłem jednorazowym opartym na czasie (TOTP).",
        "UnexpectedLambdaException":"Ten wyjątek jest wyświetlany, gdy Amazon Cognito napotka nieoczekiwany wyjątek z AWS Lambda.",
        "UserLambdaValidationException":"Ten wyjątek jest wyświetlany, gdy usługa Amazon Cognito napotka wyjątek walidacji użytkownika w usłudze AWS Lambda.",
        "LimitExceededException":"Ten wyjątek jest wyświetlany, gdy użytkownik przekroczy limit dla żądanego zasobu AWS.",
        "TooManyFailedAttemptsException":"Ten wyjątek jest wyświetlany, gdy użytkownik podejmował zbyt wiele nieudanych prób wykonania danej czynności, np. logowania.",
        "CodeDeliveryFailureException":"Ten wyjątek jest wyświetlany, gdy kod weryfikacyjny nie zostanie pomyślnie dostarczony.",
        "InvalidEmailRoleAccessPolicyException":"Ten wyjątek jest wyświetlany, gdy Amazon Cognito nie może użyć Twojej tożsamości e-mail. Kod statusu HTTP: 400.",
        "ConcurrentModificationException":"Ten wyjątek jest wyświetlany, gdy jednocześnie występują dwie lub więcej modyfikacji.",
        "EnableSoftwareTokenMFAException":"Ten wyjątek jest wyświetlany, gdy występuje niezgodność kodu i usługa nie skonfiguruje metody uwierzytelniania wieloskładnikowego (MFA) z tokenem programowym TOTP.",
   },
},
SuccessMessage: {   
    'en':'Successfully Sign In!, Redirecting to Salesforce.',
    'fr':'Connexion réussie, redirection vers Salesforce.',
    'sp':'Inicio de sesión con éxito, redirigiendo a Salesforce.',
    'gr':'Die Anmeldung war erfolgreich! Weiterleitung zu Salesforce.',
    'por':'Login com sucesso!, redirecionando para o Salesforce.',
	'pteu':"Início de sessão bem-sucedido. A redirecionar para o Salesforce.",
    'tur':'Giriş Başarılı! Salesforce Sayfasına Yönlendiriliyorsunuz.',
    'th':'ลงชื่อเข้าใช้สำเร็จ! กำลังเชื่อมต่อไปยัง Salesforce.',
    'vi':'Đăng nhập thành công !, chuyển hướng đến Salesforce.',
    'ko':'로그인했습니다!, Salesforce로 리디렉션됩니다.',
    'zh':'成功登录!,重定向至Salesforce。',
    'ru':'Введены корректные данные, перенаправление на Портал Guardian.',    
    'it':'Login riuscito, reindirizzamento a Salesforce.',
    'hu':'Bejelentkezés sikeresen!, átirányítás az értékesítési erőforráshoz.',
    'pl':'Logowanie zakończone sukcesem!, Przekierowanie do Salesforce.',
    
},
SuccessResetMessage: {   
    'en':'Réinitialisation réussie du mot de passe, redirection vers Salesforce.',
    'fr':'Réinitialiser le mot de passe avec succès, redirection vers Salesforce.',
    'sp':'La contraseña ha sido restablecida con éxito, redirigiendo a Salesforce.',
    'gr':'Das Passwort wurde erfolgreich zurückgesetzt. Umleitung zu Salesforce.',
    'por':'Redefinição de senha com sucesso, redirecionando para o Salesforce.',
	'pteu':"Reposição da palavra-passe bem-sucedida. A redirecionar para o Salesforce.",
    'tur':'Parola Sıfırlama Başarılı, Salesforce Sayfasına Yönlendiriliyorsunuz.',
    'th':'ตั้งค่ารหัสผ่านผ่านสำเร็จ  กำลังเชื่อมต่อไปยัง Salesforce',
    'vi':'Đặt lại thành công mật khẩu, chuyển hướng đến Salesforce.',
    'ko':'비밀번호를 재설정했습니다. Salesforce로 리디렉션됩니다.',
    'zh':'已成功重置密码,重定向至Salesforce。',
    'ru':'Пароль успешно сброше , перенаправление на Портал Guardian.',    
    'it':'Reimpostazione della password riuscita, reindirizzamento a Salesforce.',
    'hu':'Jelszó sikeres visszaállítása, átirányítás az értékesítési erőforráshoz.',
    'pl':'Hasło zostało zresetowane pomyślnie, przekierowanie do serwisu Salesforce.'
},
VerifyUserTitle: {
    'en':'Verify User',
    'fr':"Vérifier l'utilisateur",
    'sp':'Verificar usuario',
    'gr':'Benutzer verifizieren',
    'por':'Verificar o usuário',
	'pteu':"Verificar utilizador",
    'tur':'Kullanıcıyı Onayla',
    'th':'ตรวจสอบผู้ใช้งาน',
    'vi':'Xác minh người dùng',
    'ko':'사용자 확인',
    'zh':'验证用户',
    'ru':'Подтвердить пользователя',    
    'it':'Verifica utente',
    'hu':'Felhasználó ellenőrzése',
    'pl':'Zweryfikuj użytkownika'
},
VerifyUserInformation: {
    'en':'We have sent a password reset code by sms to @phonenumber.',
    'fr':"Nous avons envoyé un code de réinitialisation du mot de passe par sms au @phonenumber.",
    'sp':'Hemos enviado un código de restablecimiento de contraseña por sms al @phonenumber.',
    'gr':'Wir haben einen Passwort-Reset-Code per SMS an @phonenumber gesendet.',
    'por':'Enviamos um código de reset da senha por sms para @phonenumber.',
	'pteu':"Enviámos um código de reposição da palavra-passe por SMS para @númerodetelefone.",
    'tur':'@phonenumber numaralı telefona kısa mesajla bir parola sıfırlama kodu gönderdik.',
    'th':'เราได้ส่งรหัสรีเซ็ตรหัสผ่านทาง SMS ไปที่ @phonenumber',
    'vi':'Chúng tôi đã gửi mã đặt lại mật khẩu bằng sms tới @phonenumber.',
    'ko':'SMS를 통해 비밀번호 재설정 코드를 @phonenumber.',
    'zh':'我们通过sms向 @phonenumber 发送了密码重置代码。请在下面输入以重置密码。',
    'ru':'Мы отправили код сброса пароля в sms на номер @phonenumber.',    
    'it':'è stato inviato un codice di reset della password via sms a @phonenumber.',
    'hu':'Jelszó-visszaállítási kódot küldünk sms-ben a @phonenumber címre.',
    'pl':'Wysłaliśmy kod resetowania hasła za pomocą wiadomości sms na adres @phonenumber.'
},
MFAAuthAppInformation: {
    'en':'Please enter code from the Authenticator App',
    'fr':"Veuillez saisir le code de l’application d’authentification",
    'sp':'Introduzca el código de la aplicación de autenticación',
    'gr':'Bitte geben Sie den Code aus der Authenticator-App ein',
    'por':'Insira o código do Aplicativo autenticador',
	'pteu':"Introduza o código da aplicação Authenticator",
    'tur':'Lütfen Authenticator Uygulamasındaki kodu girin',
    'th':'โปรดป้อนรหัสจากแอป Authenticator',
    'vi':'Vui lòng nhập mã từ Ứng dụng Authenticator',
    'ko':'인증자 앱에서 코드를 입력해 주십시오.',
    'zh':'请输入来自身份验证应用程序的验证码',
    'ru':'Please enter code from the Authenticator App',    
    'it':'Inserisci il codice dall’app Authenticator',
    'hu':'Kérjük, adja meg az Authenticator (hitelesítő) alkalmazásban megkapott kódot',
    'pl':'Wprowadź kod z aplikacji Authenticator'
},
MFASMSInformation: {
    'en':'Please enter code by sms to @phonenumber.',
    'fr':"Veuillez saisir le code par SMS à @phonenumber de téléphone.",
    'sp':'Introduzca el código por SMS en @phonenumber.',
    'gr':'Bitte geben Sie den Code per SMS an @phonenumber ein.',
    'por':'Insira o código enviado por SMS para @phonenumber.',
	'pteu':"Introduza o código por SMS para @phonenumber.",
    'tur':'Lütfen @phonenumber numaralı telefona kısa mesaj olarak gönderilen kodu girin.',
    'th':'โปรดป้อนรหัสตาม SMS ที่ส่งไปยังหมายเลขโทรศัพท์ @phonenumber',
    'vi':'Vui lòng nhập mã gửi qua SMS đến @phonenumber.',
    'ko':'@phonenumber에 SMS로 코드를 입력해 주십시오.',
    'zh':'请通过短信将验证码发送至 @phonenumber。',
    'ru':'Please enter code by sms to @phonenumber.',    
    'it':'Inserisci il codice tramite SMS a @phonenumber.',
    'hu':'Kérjük, adja meg a kódot SMS-ben a következő telefonszámra: @phonenumber.',
    'pl':'Wprowadź kod przez SMS do @phonenumber.'
},
VerifyAuthenticationCode: {
    'en':'We have delivered the authentication code by sms to @phonenumber.',
    'fr':"Nous avons envoyé le code d'authentification par sms au @phonenumber.",
    'sp':'Hemos enviado el código de autenticación por sms al @phonenumber.',
    'gr':'Wir haben den Authentifizierungscode per SMS an @phonenumber gesendet.',
    'por':'Enviamos o código de autenticação por sms para @phonenumber.',
	'pteu':"Enviámos o código de autenticação por SMS para @phonenumber.",
    'tur':'@phonenumber numaralı telefona kısa mesajla bir onaylama kodu gönderdik.',
    'th':'เราได้ส่งรหัสยืนยันผ่านทาง SMS ไปที่ @phonenumber',
    'vi':'Chúng tôi đã gửi mã xác minh bằng sms tới @phonenumber.',
    'ko':'@phonenumber 로 인증 코드를 보내드렸습니다.',
    'zh':'我们通过以下方式发送验证码 @phonenumber',
    'ru':'Мы отправили код аутентификации в sms на номер @phonenumber.',    
    'it':'è stato inviato il codice di autenticazione via sms a @phonenumber.',
    'hu':'A hitelesítési kódot SMS-ben küldtük el a @phonenumber telefonszámra.',
    'pl':'Dostarczyliśmy kod uwierzytelniający przez sms na numer @phonenumber.'
},
VerifyUserInstruction : {
    'en':'Enter it below to reset your password.',
    'fr':"Entrez-le ci-dessous pour réinitialiser votre mot de passe.",
    'sp':'Introdúzcalo a continuación para restablecer su contraseña.',
    'gr':'Geben Sie ihn unten ein, um Ihr Passwort zurückzusetzen.',
    'por':'Digite-o abaixo para redefinir sua senha.',
	'pteu':"Introduza-o abaixo para repor a sua palavra-passe.",
    'tur':'Parolanızı sıfırlamak için kodu aşağıya girin.',
    'th':'กรุณากรอกหมายเลขเพื่อรีเซ็ตรหัสผ่านของคุณ',
    'vi':' Nhập nó vào bên dưới để đặt lại mật khẩu của bạn.',
    'ko':'비밀번호를 재설정하려면 아래에 입력하십시오.',
    'zh':'请在下面输入以重置密码。',
    'ru':'Введите его ниже, чтобы сбросить пароль.',    
    'it':"Inseriscilo qui sotto per resettare la tua password.",
    'hu':'Írja be azt az alábbiakban a jelszó visszaállításához.',
    'pl':'Wprowadź go poniżej, aby zresetować hasło.'
},
VerifyAuthenticationCodeInstruction: {
    'en':'Please enter code to complete authentication.',
    'fr':"Veuillez entrer le code pour terminer l'authentification.",
    'sp':'Por favor, introduzca el código para completar la autenticación.',
    'gr':'Bitte geben Sie den Code ein, um die Authentifizierung abzuschließen.',
    'por':'Por favor, digite o código para completar a autenticação.',
	'pteu':"Introduza o código para concluir a autenticação.",
    'tur':'Onaylama adımını tamamlamak için lütfen kodu girin.',
    'th':'กรุณากรอกรหัสเพื่อยืนยัน',
    'vi':'Vui lòng nhập mã để hoàn tất xác thực.',
    'ko':'인증을 완료하려면 코드를 입력하십시오.',
    'zh':'请输入代码以完成验证。',
    'ru':'Пожалуйста, введите код для завершения аутентификации.',    
    'it':"Inserisci il codice per completare l'autenticazione.",
    'hu':'Kérjük, adja meg a kódot a hitelesítés befejezéséhez.',
    'pl':'Wprowadź kod, aby zakończyć uwierzytelnianie.'
},
ForgotPasswordInstructionText: {   
    'en':'Enter your Username below and we will send a message to change your password',
    'fr':"Entrez votre nom d'utilisateur ci-dessous et nous vous enverrons un message pour changer votre mot de passe.",
    'sp':'Introduzca su nombre de usuario y le enviaremos un mensaje para cambiar su contraseña',
    'gr':'Geben Sie bitte Ihren Benutzernamen unten ein. Wir senden Ihnen eine Nachricht, um Ihr Passwort zu ändern.',
    'por':'Digite seu nome de usuário abaixo e nós lhe enviaremos uma mensagem para alterar sua senha.',
	'pteu':"Introduza o seu nome de utilizador abaixo e enviaremos uma mensagem para alterar a sua palavra-passe",
    'tur':'Kullanıcı adınızı aşağı girdiğinizde size parolanızı değiştirmeniz için bir mesaj göndereceğiz',
    'th':'ป้อนชื่อผู้ใช้ของคุณด้านล่างและเราจะส่งข้อความเพื่อเปลี่ยนรหัสผ่านของคุณ',
    'vi':'Nhập Tên người dùng của bạn bên dưới và chúng tôi sẽ gửi tin nhắn để thay đổi mật khẩu của bạn.',
    'ko':'아래에 사용자 이름을 입력하십시오. 비밀번호 변경 메시지를 보내드리겠습니다.',
    'zh':'在下面输入您的用户名,我们将发送一条消息以更改您的密码',
    'ru':'Введите ваше имя пользователя ниже, и мы отправим вам сообщение для изменения пароля.',    
    'it':'Inserisci il tuo nome utente qui sotto e ti invieremo un messaggio per cambiare la tua password.',
    'hu':'Írja be a felhasználónevét az alábbiakban, és mi üzenetet küldünk Önnek a jelszó megváltoztatásához.',
    'pl':'Wpisz poniżej swoją nazwę użytkownika, a my wyślemy Ci wiadomość, aby zmienić hasło.'
},
ForgotPasswordSuccessText: {   
    'en':'We have sent you a new email from portallogin@guardian.com. Please follow the instructions there to complete your password reset. ',
    'fr':'Nous vous avons envoyé un nouvel e-mail de portallogin@guardian.com. Merci de suivre les instructions pour réinitialiser le mot de passe. ',
    'sp':'Le hemos enviado un nuevo correo electrónico desde portallogin@guardian.com. Por favor, siga las instrucciones para restablecer su contraseña. ',
    'gr':'Wir haben Ihnen eine neue E-Mail von portallogin@guardian.com geschickt. Folgen Sie den Anweisungen, um das Passwort zurückzusetzen. ',
    'por':'Enviamos a você um novo e-mail de portallogin@guardian.com. Siga as instruções para concluir a redefinição da senha. ',
	'pteu':'Enviámos-lhe uma nova mensagem de correio eletrónico de portallogin@guardian.com. Siga as instruções para concluir a reposição da sua palavra-passe. ',
    'tur':'Size portallogin@guardian.com adresinden yeni bir e-posta gönderdik. Şifre sıfırlama işleminizi tamamlamak için lütfen buradaki talimatları izleyin. ',
    'th':'เราได้ส่งอีเมลใหม่จาก portallogin@guardian.com ให้คุณแล้ว โปรดทำตามคำแนะนำเพื่อรีเซ็ตรหัสผ่านของคุณให้เสร็จสมบูรณ์. ',
    'vi':'Chúng tôi đã gửi cho bạn một email mới từ portallogin@guardian.com. Vui lòng làm theo hướng dẫn ở đó để hoàn tất việc đặt lại mật khẩu của bạn. ',
    'ko':'portallogin@guardian.com 에서 새 이메일을 보내드렸습니다. 비밀번호 재설정을 완료하려면 다음 지침을 따르세요. ',
    'zh':'我们已经向您发送了一封来自 portallogin@guardian.com 的新邮件. 请按照说明完成密码重置. ',
    'it':'Vi abbiamo inviato una nuova e-mail da portallogin@guardian.com. Seguire le istruzioni per completare la reimpostazione della password. ',
    'hu':'Küldtünk Önnek egy új e-mailt a portallogin@guardian.com címről. Kérjük, kövesse az ott található utasításokat a jelszó beállításához. ',
    'pl':'Otrzymałeś nową wiadomość e-mail od portallogin@guardian.com. Postępuj zgodnie z instrukcjami, aby dokończyć resetowanie hasła. ',
},
CodeLabelTxt: {   
    'en':'Code',
    'fr':'Code',
    'sp':'Código',
    'gr':'Code',
    'por':'Código',
	'pteu':"Código",
    'tur':'Kod',
    'th':'รหัส',
    'vi':'Mã số',
    'ko':'코드',
    'zh':'代码(Code)',
    'ru':'Код',    
    'it':'Codice',
    'hu':'Kód',
    'pl':'Kod'
},
ChangePasswordTxt: {   
    'en':'Change Password',
    'fr':'Changer le mot de passe',
    'sp':'Cambiar la contraseña',
    'gr':'Passwort ändern',
    'por':'Mudança de senha',
	'pteu':"Alterar palavra-passe",
    'tur':'Parola Değiştir',
    'th':'เปลี่ยนรหัสผ่าน',
    'vi':'Đổi mật khẩu',
    'ko':'비밀번호 변경하기',
    'zh':'更改密码',
    'ru':'Измененить пароль',    
    'it':'Modifica della password',
    'hu':'Jelszó módosítása' ,
    'pl':'Zmiana hasła'
},

CodeValidationMessage: {   
    'en':'Code must be 6 digit number.',
    'fr':'Le code doit être un numéro à 6 chiffres.',
    'sp':'El código debe ser un número de 6 dígitos.',
    'gr':'Der Code muss eine 6-stellige Zahl sein.',
    'por':'O código deve ser um número de 6 dígitos.',
	'pteu':"O código tem de ser um número de 6 dígitos.",
    'tur':'Kod, 6 haneli bir sayı olmalıdır.',
    'th':'รหัสผ่านต้องมีอย่างน้อย 6 หลักขึ้นไป',
    'vi':'Mã phải là số có 6 chữ số.',
    'ko':'코드는 6자리 숫자여야 합니다.',
    'zh':'代码必须是6位数字。',
    'ru':'Код должен состоять из 6 цифр.',    
    'it':'Il codice deve essere un numero di 6 cifre.',
    'hu':'A kódnak 6 számjegyűnek kell lennie.',
    'pl':'Kod musi składać się z 6 cyfr.'
},
ChangePasswordSuccessTxt: {   
    'en':'Successfully change password, redirecting to Salesforce.',
    'fr':'Changement du mot de passe réussi, rediriger vers Salesforce.',
    'sp':'La contraseña ha sido cambiada con éxito, redirigiendo a Salesforce.',
    'gr':'Das Passwort wurde erfolgreich geändert. Weiterleitung zu Salesforce.',
    'por':'Mudança de senha com sucesso, redirecionando para o Salesforce.',
	'pteu':"Alteração da palavra-passe bem-sucedida. A redirecionar para o Salesforce.",
    'tur':'Parola değiştirme başarılı, Salesforce sayfasına yönlendiriliyorsunuz.',
    'th':'เปลี่ยนรหัสผ่านสำเร็จ  กำลังเชื่อมต่อไปยัง Salesforce.',
    'vi':'Thay đổi thành công mật khẩu, chuyển hướng đến Salesforce.',
    'ko':'비밀번호를 변경했습니다. Salesforce로 리디렉션합니다.',
    'zh':'成功更改密码,重定向到Salesforce',
    'ru':'Пароль успешно изменен, перенаправление на Портал Guardian.',    
    'it':'Password resettata con successo, reindirizzamento a Salesforce.',
    'hu':'Jelszó visszaállítása sikeres, átirányítás az értékesítési csapathoz.',
    'pl':'Hasło zostało zmienione pomyślnie, przekierowanie do działu sprzedaży'
},
SupportEmail: {   
    'en':'support.eu@guardian.com',
    'fr':'support.eu@guardian.com',
    'sp':'support.eu@guardian.com',
    'gr':'support.eu@guardian.com',
    'por':'support.eu@guardian.com',
	'pteu':'support.eu@guardian.com',
    'tur':'support.eu@guardian.com',
    'th':'support.ap@guardian.com',
    'vi':'support.ap@guardian.com',
    'ko':'support.ap@guardian.com',
    'zh':'support.ap@guardian.com',
    'ru':'support@guardian.com',    
    'it':'support.eu@guardian.com',
    'hu':'support.eu@guardian.com',
    'pl':'support.eu@guardian.com'
},
SelectMFATitle: {   
    'en':'Choose a multi-factor authentication (MFA) method',
    'fr':'Choisir une méthode d’authentification multifactorielle (MFA)',
    'sp':'Elegir un método de autenticación multifactor (MFA)',
    'gr':'Wählen Sie eine Multi-Faktor-Authentifizierungsmethode (MFA)',
    'por':'Escolha um método de autenticação multifator (MFA)',
	'pteu':"Escolha um método de autenticação multifator (MFA)",
    'tur':'Lütfen çoklu onaylama (MFA) metodunu seçin',
    'th':'เลือกวิธีการยืนยันตัวตนโดยใช้หลายปัจจัย (MFA)',
    'vi':'Chọn một phương thức xác thực đa yếu tố (MFA)',
    'ko':'다단계 인증(MFA) 방법을 선택하십시오.',
    'zh':'选择多重身份验证 (MFA) 方法',
    'ru':'Choose a multi-factor authentication (MFA) method',    
    'it':'Scegli un metodo di autenticazione a più fattori (MFA)',
    'hu':'Válasszon többlépcsős hitelesítési (MFA) módszert',
    'pl':'Wybierz metodę uwierzytelniania wieloskładnikowego (MFA)'
},
SelectMFADescription: {   
    'en':'You must configure MFA before you can sign in. Choose how you want to authenticate.',
    'fr':'Vous devez configurer la MFA avant de vous connecter. Choisissez la méthode d’authentification.',
    'sp':'Debe configurar la MFA antes de iniciar sesión. Elija cómo desea autenticar.',
    'gr':'Sie müssen MFA konfigurieren, bevor Sie sich anmelden können. Wählen Sie aus, wie Sie sich authentifizieren möchten.',
    'por':'É necessário configurar a MFA antes de fazer login. Escolha como deseja autenticar.',
	'pteu':"Deve configurar a MFA antes de iniciar sessão. Escolha como deseja fazer a autenticação.",
    'tur':'Giriş yapmadan önce MFA metodunu yapılandırmalısınız. Nasıl bir doğrulama istediğinizi seçin.',
    'th':'คุณต้องกำหนดค่า MFA เพื่อลงชื่อเข้าใช้งานได้ เลือกวิธีที่คุณต้องการรับรองความถูกต้อง',
    'vi':'Bạn phải đặt cấu hình phương thức MFA trước khi có thể đăng nhập. Chọn cách xác thực.',
    'ko':'로그인하려면 먼저 MFA를 구성해야 합니다. 인증 방법을 선택하십시오.',
    'zh':'您必须配置 MFA 才能登录。选择您想要进行身份验证的方式。',
    'ru':'You must configure MFA before you can sign in. Choose how you want to authenticate.',    
    'it':'Devi configurare l’MFA prima di poter accedere. Scegli come effettuare l’autenticazione.',
    'hu':'A bejelentkezés előtt konfigurálnia kell az MFA-t. Válassza ki a hitelesítés módját.',
    'pl':'Przed zalogowaniem się musisz skonfigurować MFA. Wybierz sposób uwierzytelniania.'
},
SelectMFA_SMS : {   
    'en':'SMS',
    'fr':'SMS',
    'sp':'SMS',
    'gr':'SMS',
    'por':'SMS',
	'pteu':"SMS",
    'tur':'Kısa Mesaj',
    'th':'SMS',
    'vi':'SMS',
    'ko':'SMS',
    'zh':'SMS',
    'ru':'SMS',    
    'it':'SMS',
    'hu':'SMS',
    'pl':'SMS'
},
SelectMFA_EMAIL : {   
    'en':'E-Mail',
    'fr':'E-Mail',
    'sp':'E-Mail',
    'gr':'E-Mail',
    'por':'E-Mail',
	'pteu':"E-Mail",
    'tur':'E-Mail',
    'th':'E-Mail',
    'vi':'E-Mail',
    'ko':'E-Mail',
    'zh':'E-Mail',
    'ru':'E-Mail',    
    'it':'E-Mail',
    'hu':'E-Mail',
    'pl':'E-Mail'
},
SelectMFA_SMSDescription: {   
    'en':'Authenticate using a code sent via text message to your phone.',
    'fr':'Authentifiez-vous à l’aide d’un code envoyé par SMS sur votre téléphone.',
    'sp':'Autenticar con un código enviado por mensaje de texto a su teléfono.',
    'gr':'Authentifizieren Sie sich mit einem Code, der per SMS an Ihr Telefon gesendet wird.',
    'por':'Autentique usando um código enviado por mensagem de texto para seu telefone.',
	'pteu':"Faça a autenticação utilizando um código enviado por mensagem de texto para o seu telefone.",
    'tur':'Telefonunuza gönderilecek mesajdaki kodu kullanarak doğrulayın.',
    'th':'รับรองความถูกต้องโดยใช้รหัสที่ส่งไปยังโทรศัพท์ของคุณ',
    'vi':'Xác thực bằng mã gửi qua tin nhắn văn bản đến điện thoại của bạn.',
    'ko':'문자 메시지를 통해 휴대폰으로 전송된 코드를 사용하여 인증하십시오.',
    'zh':'使用通过短信发送到您手机的验证码进行身份验证。',
    'ru':'Authenticate using a code sent via text message to your phone.',    
    'it':'Effettua l’autenticazione usando un codice inviato tramite messaggio di testo al telefono.',
    'hu':'Hitelesítés a telefonjára szöveges üzenetben küldött kóddal.',
    'pl':'Uwierzytelnij za pomocą kodu wysłanego w wiadomości tekstowej na Twój telefon.'
}, 
SelectMFA_APP: {   
    'en':'Authenticator app',
    'fr':'Application d’authentification',
    'sp':'Aplicación de autenticación',
    'gr':'Authenticator-App',
    'por':'Aplicativo autenticador',
	'pteu':"Aplicação Authenticator",
    'tur':'Authenticator uygulaması',
    'th':'แอป Authenticator',
    'vi':'Ứng dụng Authenticator',
    'ko':'인증자 앱',
    'zh':'身份验证应用程序',
    'ru':'Authenticator app',    
    'it':'App Authenticator',
    'hu':'Hitelesítő alkalmazás',
    'pl':'Aplikacja Authenticator'
},
SelectMFA_APPDescription: {   
    'en':'Authenticate using a code generated by an app installed on your mobile device or computer.',
    'fr':'Authentifiez-vous à l’aide d’un code généré par une application installée sur votre téléphone portable ou votre ordinateur.',
    'sp':'Verificar con un código generado por una aplicación instalada en su dispositivo móvil u ordenador.',
    'gr':'Authentifizieren Sie sich mit einem Code, der von einer auf Ihrem Mobilgerät oder Computer installierten App generiert wird.',
    'por':'Autentique usando um código gerado por um aplicativo instalado em seu dispositivo móvel ou computador.',
	'pteu':"Faça a autenticação utilizando um código gerado por uma aplicação instalada no seu dispositivo móvel ou computador.",
    'tur':'Telefonunuza veya bilgisayarınıza indireceğiniz bir uygulamada gösterilecek kodu kullanarak doğrulayın.',
    'th':'รับรองความถูกต้องโดยใช้รหัสที่จากแอปที่ติดตั้งบนอุปกรณ์มือถือหรือคอมพิวเตอร์ของคุณ',
    'vi':'Xác thực bằng mã được tạo từ ứng dụng cài đặt trên thiết bị di động hoặc máy tính của bạn.',
    'ko':'모바일 장치 또는 컴퓨터에 설치된 앱에서 생성된 코드를 사용하여 인증하십시오.',
    'zh':'使用在您的移动设备或计算机上安装的应用程序生成的验证码进行身份验证。',
    'ru':'Authenticate using a code generated by an app installed on your mobile device or computer.',    
    'it':'Effettua l’autenticazione usando un codice generato da un’app installata sul dispositivo mobile o sul computer.',
    'hu':'Hitelesítés a mobileszközére vagy számítógépére telepített alkalmazás által generált kóddal.',
    'pl':'Uwierzytelnij za pomocą kodu wygenerowanego przez aplikację zainstalowaną na urządzeniu mobilnym lub komputerze.'
},
SelectEMAIL: {   
    'en':'Email',
    'fr':'Email',
    'sp':'Email',
    'gr':'Email',
    'por':'Email',
	'pteu':'Email',
    'tur':'Email',
    'th':'Email',
    'vi':'Email',
    'ko':'Email',
    'zh':'Email',
    'ru':'Email',    
    'it':'Email',
    'hu':'Email',
    'pl':'Email'
},
SelectEmailDescription: {   
    'en':'Authenticate using a code sent via email.',
    'fr':"S'authentifier à l'aide d'un code envoyé par e-mail",
    'sp':'Autentifíquese mediante un código enviado por correo electrónico.',
    'gr':'Authentifizierung mit einem per E-Mail zugesandten Code.',
    'por': 'Autenticar usando um código enviado por e-mail.',
    'pteu': 'Autentique-se utilizando o código enviado por e-mail.',
    'tur':'E-posta yoluyla gönderilen kodu kullanarak kimliğinizi doğrulayınız.',
    'th':'ยืนยันตัวตน โดยใช้รหัส OTP ที่ได้รับทางอีเมล',
    'vi':'Xác thực bằng mã được gửi qua email',
    'ko':'이메일을 통해 전송된 코드를 사용하여 인증합니다.',
    'zh':'使用电子邮件发送的代码进行身份验证',
    'ru':'Authenticate using a code sent via email.',    
    'it':'Autenticazione tramite un codice inviato via e-mail.',
    'hu':"Hitelesítés e-mailben küldött kóddal",
    'pl':'Uwierzytelnianie przy użyciu kodu wysłanego pocztą elektroniczną.'
},
SelectMFA_BUTTONLABEL: {   
    'en':'Continue',
    'fr':'Continuer',
    'sp':'Continuar',
    'gr':'Fortfahren',
    'por':'Continuar',
	'pteu':'Continuar',
    'tur':'Devam',
    'th':'ดำเนินการต่อ',
    'vi':'Tiếp tục',
    'ko':'계속',
    'zh':'继续',
    'ru':'Continue',    
    'it':'Continua',
    'hu':'Folytatás',
    'pl':'Kontynuuj'
},
REGISTER_APP: {   
    'en':'Register App',
    'fr':'Enregistrer l’application',
    'sp':'Registrar aplicación',
    'gr':'App registrieren',
    'por':'Registrar aplicativo',
	'pteu':"Registar aplicação",
    'tur':'Register Uygulaması',
    'th':'ลงทะเบียนแอป',
    'vi':'Đăng ký ứng dụng',
    'ko':'앱 등록',
    'zh':'注册应用程序',
    'ru':'Register App',    
    'it':'Registra app',
    'hu':'Alkalmazás regisztrálása',
    'pl':'Zarejestruj aplikację'
},
MANAGE_MFA: {   
    'en':'Manage MFA',
    'fr':'Gérer la MFA',
    'sp':'Gestionar MFA',
    'gr':'MFA verwalten',
    'por':'Gerenciar MFA',
	'pteu':"Gerir MFA",
    'tur':'MFA Yönetimi',
    'th':'จัดการ MFA',
    'vi':'Quản lý MFA',
    'ko':'MFA 관리',
    'zh':'管理 MFA',
    'ru':'Manage MFA',    
    'it':'Gestisci MFA',
    'hu':'MFA kezelése',
    'pl':'Zarządzaj MFA'
},
SCANQR: {   
    'en':'Scan QR Code',
    'fr':'Scanner le QR code',
    'sp':'Escanear código QR',
    'gr':'QR-Code scannen',
    'por':'Leia o QR Code',
	'pteu':"Digitalizar código QR",
    'tur':'QR Kodu Tarat',
    'th':'สแกน QR Code',
    'vi':'Quét mã QR',
    'ko':'QR 코드 스캔',
    'zh':'扫描二维码',
    'ru':'Scan QR Code',    
    'it':'Scansiona codice QR',
    'hu':'QR-kód beolvasása',
    'pl':'Zeskanuj kod QR'
},
ENTERCODE: {   
    'en':'Or Enter Code Into Your App',
    'fr':'ou saisir le code dans votre application',
    'sp':'También puede introducir el código en la aplicación',
    'gr':'Oder Code in Ihre App eingeben',
    'por':'Ou insira o código no aplicativo',
	'pteu':"Ou introduza o código na sua aplicação",
    'tur':'Veya Kodu Uygulamaya Gir',
    'th':'หรือป้อนรหัสลงในแอปของคุณ',
    'vi':'Hoặc nhập mã vào ứng dụng của bạn',
    'ko':'또는 앱에 코드 입력',
    'zh':'或在您的应用程序中输入验证码',
    'ru':'Or Enter Code Into Your App',    
    'it':'Oppure inserisci il codice nella tua app',
    'hu':'Vagy írja be a kódot az alkalmazásba',
    'pl':'Lub wprowadź kod do swojej aplikacji'
},
DEVICE_NAME: {   
    'en':'Frendly Device Name',
    'fr':'Nom du périphérique Frendly',
    'sp':'Nombre del dispositivo',
    'gr':'Anzeigename des Geräts',
    'por':'Nome amigável do dispositivo',
	'pteu':"Nome do dispositivo",
    'tur':'Güvenilir Cihaz İsmi',
    'th':'ชื่ออุปกรณ์ที่เรียกง่าย',
    'vi':'Tên dễ nhớ của thiết bị',
    'ko':'식별용 장치 이름',
    'zh':'友好的设备名称',
    'ru':'Frendly Device Name',    
    'it':'Nome descrittivo del dispositivo',
    'hu':'Eszköz felhasználóbarát neve',
    'pl':'Przyjazna nazwa urządzenia'
},
MFA_VERIFY: {   
    'en':'Verify',
    'fr':'Vérifier',
    'sp':'Verificar',
    'gr':'Überprüfen',
    'por':'Verificar',
	'pteu':"Verificar",
    'tur':'Doğrula',
    'th':'ตรวจสอบยืนยัน',
    'vi':'Xác minh',
    'ko':'확인',
    'zh':'验证',
    'ru':'Verify',    
    'it':'Verifica',
    'hu':'Ellenőrzés',
    'pl':'Zweryfikuj'
},
MFA_PREFERENCE: {   
    'en':'MFA Preference',
    'fr':'Préférence MFA',
    'sp':'Preferencia MFA',
    'gr':'MFA-Präferenz',
    'por':'Preferência de MFA',
	'pteu':"Preferência MFA",
    'tur':'MFA Tercihi',
    'th':'การกำหนดลักษณะ MFA',
    'vi':'Tùy chọn MFA',
    'ko':'MFA 기본 설정',
    'zh':'MFA 首选项',
    'ru':'MFA Preference',    
    'it':'Preferenze per MFA',
    'hu':'MFA preferencia',
    'pl':'Preferencje MFA'
},
MFA_PREFERENCE_ENABLED: {   
    'en':'Enabled',
    'fr':'Activé',
    'sp':'Habilitado',
    'gr':'Aktiviert',
    'por':'Ativada',
	'pteu':"Ativado",
    'tur':'Etkinleştirildi',
    'th':'เปิดใช้งานแล้ว',
    'vi':'Đã bật',
    'ko':'활성화됨',
    'zh':'已启用',
    'ru':'Enabled',    
    'it':'Abilitato',
    'hu':'Engedélyezve',
    'pl':'Włączone'
},
MFA_PREFERENCE_PREFERED: {   
    'en':'Prefered',
    'fr':'Préféré',
    'sp':'Preferido',
    'gr':'Bevorzugt',
    'por':'Preferencial',
	'pteu':"Preferencial",
    'tur':'Tercih Edildi',
    'th':'ตัวเลือกที่ต้องการ',
    'vi':'Ưu tiên',
    'ko':'기본 설정됨',
    'zh':'首选',
    'ru':'Prefered',    
    'it':'Preferito',
    'hu':'Előnyben részesített',
    'pl':'Preferowane'
},
MFA_PREFERENCE_SAVE: {   
    'en':'Save',
    'fr':'Enregistrer',
    'sp':'Guardar',
    'gr':'Speichern',
    'por':'Salvar',
	'pteu':"Guardar",
    'tur':'Kaydet',
    'th':'บันทึก',
    'vi':'Lưu',
    'ko':'저장',
    'zh':'保存',
    'ru':'Save',    
    'it':'Salva',
    'hu':'Mentés',
    'pl':'Zapisz'
},
REGISTER_APP11: {   
    'en':'Continue',
    'fr':'Continuer',
    'sp':'Continuar',
    'gr':'Fortfahren',
    'por':'Continuar',
	'pteu':'Continuar',
    'tur':'Devam',
    'th':'ดำเนินการต่อ',
    'vi':'Tiếp tục',
    'ko':'계속',
    'zh':'继续',
    'ru':'Continue',    
    'it':'Continua',
    'hu':'Folytatás',
    'pl':'Kontynuuj'
},
REGISTER_APP12: {   
    'en':'Continue',
    'fr':'Continuer',
    'sp':'Continuar',
    'gr':'Fortfahren',
    'por':'Continuar',
	'pteu':'Continuar',
    'tur':'Devam',
    'th':'ดำเนินการต่อ',
    'vi':'Tiếp tục',
    'ko':'계속',
    'zh':'继续',
    'ru':'Continue',    
    'it':'Continua',
    'hu':'Folytatás',
    'pl':'Kontynuuj'
},
};

var GetTranslations = function(language){
    var result = {};
    Object.keys(i18n).forEach((key, index) => {
        //Lookup the language or if not found use 'en'
        result[key]=(i18n[key][language])?i18n[key][language]: i18n[key]['en'];
    });
    return result;
};

var GetConvertedLangCode = function(language){
    var result;
    result = i18n['ConvertedLanguages'][language]? i18n['ConvertedLanguages'][language]: i18n['ConvertedLanguages']['en'];
    return result;
};

const SelectList = {
    GetTranslations: GetTranslations,
    i18n: i18n,
    GetConvertedLangCode: GetConvertedLangCode
};

export default SelectList;

